// src/views/CrmApp.js
import React, { useState, useEffect, useCallback, useRef } from 'react'; // clkref-1a2b3c4d — useRef for synchronous clock guard
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import { db, functions } from '../firebase/config';
import { httpsCallable } from 'firebase/functions';
// wpauthor-5d3f8a26 — writeBatch dropped: its only remaining use was the Work
// Performed mirror write, which moved server-side into writeWorkPerformedEntry.
import { doc, getDoc, collection, query, onSnapshot, deleteDoc, updateDoc, addDoc, where, serverTimestamp, arrayUnion, setDoc, limit, orderBy, getDocs, writeBatch } from 'firebase/firestore'; // writeBatch: webpunch-6c4a9e21
// r1-p7-requote-import-4e8b2d71 — schema helpers for Phase 7.2 re-quote (fresh itemIds + default selection type)
import { generateItemId, DEFAULT_SELECTION_TYPE, resolveDocTerminology, resolveCreateSalesPersonId, resolveQuoteValidityDays, normalizeStatus, QUOTE_STATUSES } from '../utils/quoteSchema'; // r1-p1-docterm-crm-import-5d9a2f83 qvalid-7c2e4a91 qclose-3e8a5c17
import { classifyOpenShift, classifyClockOut, buildSelfReportedEndUpdate } from '../utils/shiftGuard'; // clkstale-a5f0d7e2 — stale-shift self-report guards
import ShiftClockOutPrompt from '../components/common/ShiftClockOutPrompt'; // clkstale-a5f0d7e2
import { format } from 'date-fns';
import CustomerManagementView from './CustomerManagementView';
import QuotesView from './QuotesView';
import InvoicesView from './InvoicesView';
import EmailView from './EmailView';
import RequestsView from './RequestsView';
import QuoteFormModal from '../components/crm/QuoteFormModal';
import * as lineIds from '../utils/lineIds'; // lineidweb-9e4a2d17 — permanent per-line IDs, lineage, the one template function
import { normalizeBillTo } from '../utils/billTo'; // billto-crm-import-5a8d3f61
import { resolveBillLabor, priorBilledFromInvoices, computeLaborBilling } from '../utils/laborBilling'; // laborbill-one-rule-6c2a9e47
import { collectPriorJobInvoices, jobInvoiceWarning } from '../utils/jobInvoiceGuard'; // jobinvguard-5e1b7c84
import { hasInvoiceableLines, NO_LINES_INVOICE_MESSAGE } from '../utils/jobLines'; // nolines-59a4771f — no line items, no invoice
import CustomerFormModal from '../components/crm/CustomerFormModal'; 
import InvoiceFormModal from '../components/crm/InvoiceFormModal';
import { fetchCustomerNoteGroups } from '../utils/noteInclusions'; // r1-3f2-crm-import-9d2e7a4c
import QuoteDetailsView from './QuoteDetailsView';
import InvoiceDetailsView from './InvoiceDetailsView';
import ConfirmationModal from '../components/common/ConfirmationModal'; // seamE-1f3a9c7d — reused confirm gate for double-conversion warning
import { withCustomerName, compareCustomersByName } from '../utils/customerDisplay'; // webcustname-7c4a1e92
import { formatCurrency, isImportedInvoice } from '../utils/formatters'; // seamE-1f3a9c7d — deposit-amount wording in the warning; impro-3c8f1a57
import RecurringInvoicesView from './RecurringInvoicesView'; // recinv-crmapp-imp-4b7e1a93
import RecurringInvoiceDetailsView from './RecurringInvoiceDetailsView'; // recinv-crmapp-imp-4b7e1a93
import RecurringInvoiceFormModal from '../components/crm/RecurringInvoiceFormModal'; // recinvform-crmapp-imp-9f3c2a71
import JobFormModal from '../components/crm/JobFormModal';
import CalendarView from './CalendarView';
import ProfitabilityReport from './ProfitabilityReport';
import ServiceRevenueReport from './reports/ServiceRevenueReport';
import JobQuickViewModal from '../components/crm/JobQuickViewModal';
import TimesheetsView from './TimesheetsView';
import HomeView from './HomeView';
import SettingsPage from './SettingsPage';
// mailtok-2c7f9e51 — the Firebase-popup Microsoft connect was removed (see below); it was the
// only thing in this file using firebase/auth, `auth` and `microsoftProvider`.
import OverdueEventsReport from './OverdueEventsReport';
import CancellationReport from './CancellationReport';
import ReportsHome, { EstimatesOnlyReportsHome } from './ReportsHome'; // qreport-5b8e2c64
import { resolveReportViewer } from '../utils/quoteReporting'; // qreport-5b8e2c64
import EmailCampaignsView from './EmailCampaignsView';
import JobManagementView from './JobManagementView';
import EmployeeProfilesView from './EmployeeProfilesView';
import EmployeeProfileModal from '../components/crm/EmployeeProfileModal';
import { can, PERMISSIONS, canTechEditJob, canOpenTimesheets } from '../utils/permissions'; // tsmgr-5a2c8e71
// wpauthor-5d3f8a26 — SEAM E removed this file's import of the flatten and the
// entry builder. Nothing on the web writes Work Performed entries or the mirror
// any more; writeWorkPerformedEntry owns both, server-side, in one transaction.
// The src/ twin of the util is still used — by JobQuickViewModal, for READING
// (sorting, bylines, the active-entry test). Only the writers left.
import { getArrivalWindow, buildArrivalWindowSnapshot } from '../utils/arrivalWindows'; // aw-crm-5e6f7081 // aw-seam4
import { resolveFirstAvailableDate, browserDates } from '../utils/firstAvailableDate'; // fa-crm-8b24f0d6
import ExpensesView from './ExpensesView';
import ExpenseReportView from './reports/ExpenseReportView';
import RoutesView from './RoutesView';
import WeeklyPlannerView from './WeeklyPlannerView';
import FlaggedInbox from './FlaggedInbox'; // PHASE 1.6 VERIFIER: r1-16-web-crmapp-route-16a3f2b8
// doced-8f3a61c2 — the full-page estimate (switch documentPagesEnabled.estimates; test company only)
import EstimatePage from '../components/documents/EstimatePage';
import { isDocumentPageOn } from '../utils/documentPages';
import { estimatePath } from '../utils/estimateEditor';
import { useTaxCodesDoc } from '../utils/taxExemptionUi'; // taxlines5-a4c81e37
import { carriedExemptionOffFields, onSiteLineTaxFields } from '../utils/documentLineTax'; // taxlines5-a4c81e37
// sopweb-bdb7afcd — SOPs Library screens (switch sopsLibraryEnabled exactly true + Manager and up / god mode)
import SopsPage from '../components/sops/SopsPage';
import { showSopsMenu } from '../utils/sopsUi'; // sopread-7e4c2a93 — My SOPs for everyone; manager pages checked inside SopsPage

const ProtectedRoute = ({ requiredPermission, currentUserProfile, children }) => {
    if (!requiredPermission) return children;
    const hasAccess = can(currentUserProfile, requiredPermission);
    if (!hasAccess) {
        return <Navigate to="/home" replace />;
    }
    return children;
};

// ─── Pure utility — mirrors JobFormModal.findFirstAvailable ─────────────────
// Takes plain values (no component state) so handleBookNow can call it
// without being inside the JobFormModal component.
// fa-crm-8b24f0d6 — thin wrapper over the shared resolver (Seam 3a). Keeps the positional
// signature so existing callers (handleBookNow) are untouched. Behaviour byte-for-byte the
// prior inline loop: browser-local walk, UTC-ISO day key, tomorrow as the terminal fallback.
const computeFirstAvailableDate = (jobs, companySettings, durationMins, arrivalWindow = 'morning') => {
    const travelBuffer = Number(companySettings?.payrollDefaults?.travelBufferMinutes ?? 30);
    const workDays     = companySettings?.payrollDefaults?.workDays ??
        ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
    const d = resolveFirstAvailableDate({ jobs, arrivalWindow, durationMins, travelBuffer, workDays, dates: browserDates, companySettings }); // aw-seam4
    if (d) return d;
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
    return tomorrow;
};

// shiftactive-d8e4f6a2 — single source of truth for "which open shift is active":
// the most recently STARTED one. We sort client-side instead of orderBy('shiftStart')
// to avoid a composite index on (shiftEnd, shiftStart); the open-shift set is only ever
// 0-2 docs. A just-created shift whose serverTimestamp hasn't resolved reads as null
// locally, so treat a missing shiftStart as "now" (newest) — a fresh clock-in wins over
// an older orphan. Gate 3's shiftGuard.js will reuse this.
const selectActiveOpenShift = (openShifts) => {
    if (!openShifts || openShifts.length === 0) return null;
    return openShifts.reduce((newest, s) => {
        const sMs = s.shiftStart?.toMillis ? s.shiftStart.toMillis() : Infinity;
        const nMs = newest.shiftStart?.toMillis ? newest.shiftStart.toMillis() : Infinity;
        return sMs >= nMs ? s : newest;
    });
};

// calreturn-7b2e9d41 — the calendar's team filter persists per user, matching the Jobs
// screen's convention (marker 7c3af9d1, JobManagementView.js:40): `spatchy_*` key with a
// trailing uid, versioned JSON payload, client-only. No Firestore, no cross-device sync.
const CALENDAR_TEAM_FILTER_KEY_PREFIX = 'spatchy_calendar_team_filter_';

// Returns the stored id list, or null when nothing valid is stored. The null-vs-empty
// distinction is load-bearing: null means "never chosen" and seeds to only-me, while an
// empty array is the legitimate result of the calendar's existing Clear all button and
// must be preserved as-is. Never throws — private mode and quota both can.
const readCalendarTeamFilter = (profileId) => {
    try {
        const raw = localStorage.getItem(CALENDAR_TEAM_FILTER_KEY_PREFIX + profileId);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || !Array.isArray(parsed.ids)) return null;
        return parsed.ids.filter(id => typeof id === 'string');
    } catch {
        return null;
    }
};

const CrmApp = ({ user, currentUserProfile }) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    // State Management
    const [companySettings, setCompanySettings] = useState({});
    const [customers, setCustomers] = useState([]);
    const [services, setServices] = useState([]);
    const [users, setUsers] = useState([]);
    const [resources, setResources] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    
    const [composeState, setComposeState] = useState({ isOpen: false, recipient: '', subject: '', body: '' });
    
    // Connection States
    const [isGmailConnected, setIsGmailConnected] = useState(false);
    const [isCalendarConnected, setIsCalendarConnected] = useState(false);
    const [isOutlookConnected, setIsOutlookConnected] = useState(false);
    const [isMsCalendarConnected, setIsMsCalendarConnected] = useState(false);
    const [emailProvider, setEmailProvider] = useState(null);
    const [emailAccessToken, setEmailAccessToken] = useState(null);
    const [emailTokenExpiresAt, setEmailTokenExpiresAt] = useState(null);

    const [initialEntityId, setInitialEntityId] = useState(null);
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
    const [editingQuote, setEditingQuote] = useState(null);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [editingCustomer, setEditingCustomer] = useState(null);
    const [initialCustomerModalTab, setInitialCustomerModalTab] = useState('contact');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [viewingQuote, setViewingQuote] = useState(null);
    const [isJobModalOpen, setIsJobModalOpen] = useState(false);
    const [editingJob, setEditingJob] = useState(null);
    const [viewingInvoice, setViewingInvoice] = useState(null);
    const [viewingSchedule, setViewingSchedule] = useState(null); // recinv-crmapp-state-8c3d6f24
    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false); // recinvform-crmapp-state-9f3c2a71
    const [editingSchedule, setEditingSchedule] = useState(null); // recinvform-crmapp-state-9f3c2a71
    const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
    const [editingInvoice, setEditingInvoice] = useState(null);
    const [recordPaymentForId, setRecordPaymentForId] = useState(null); // h1s6-8b2f4d19 — open Record Payment once the editor closes
    const [isQuickViewModalOpen, setIsQuickViewModalOpen] = useState(false);
    const [quickViewJob, setQuickViewJob] = useState(null);
    const [activeShift, setActiveShift] = useState(null);
    // clockbusy-e3b6c8a4 — in-flight flag: disables the clock button between a click and
    // the write landing, so a double-click can't create a second open shift.
    const [clockBusy, setClockBusy] = useState(false);
    // clkhold-5e6f7a8b — the PRIMARY clock guard is a ref (synchronous), not the
    // clockBusy state: useState doesn't update in time to stop a same-tick second
    // click. clockBusy state survives only to drive the button's disabled/greyed look.
    const clockBusyRef = useRef(false);
    // 'in' | 'out' | null — the clock transition we're holding the button for until
    // the SERVER confirms it (not the ~50ms local latency-compensated snapshot).
    const pendingActionRef = useRef(null);
    // setTimeout id — 8s backstop so a listener that never server-acks can't lock
    // the button forever (rural Vancouver Island signal can take several seconds).
    const clockFallbackRef = useRef(null);
    const releaseClock = useCallback(() => {
        if (clockFallbackRef.current) { clearTimeout(clockFallbackRef.current); clockFallbackRef.current = null; }
        pendingActionRef.current = null;
        clockBusyRef.current = false;
        setClockBusy(false);
    }, []);
    // clkstale-a5f0d7e2 — the self-report prompt. shiftPromptOpenRef is a SYNCHRONOUS
    // re-entry gate (like clockBusyRef): while a prompt is awaiting the human, the
    // clock handlers early-return. The shipped guard (clockBusyRef / pendingActionRef /
    // 8s fallback / server-ack release) is UNTOUCHED and is armed only at prompt submit,
    // never while the modal is open — so the 8s fallback can't misfire mid-interaction.
    const [shiftPromptOpen, setShiftPromptOpen] = useState(false);
    const [shiftPromptData, setShiftPromptData] = useState(null); // { mode, shift, nextShiftStart }
    const shiftPromptOpenRef = useRef(false);
    const [isConverting, setIsConverting] = useState(false);
    // seamE-2b8e4d61 — while a double-conversion confirmation is pending, holds
    // { quote, customer, priorNumbers, depositApplied, depositAmount, depositInvoiceNumber }.
    const [convertWarning, setConvertWarning] = useState(null);
    const [jobInvoiceWarningState, setJobInvoiceWarningState] = useState(null); // jobinvguard-5e1b7c84 — { job, priorNumbers }
    const [invoiceSortConfig, setInvoiceSortConfig] = useState({ key: 'createdAt', direction: 'descending' });
    const [loadingDeepLink, setLoadingDeepLink] = useState(false);
    const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);

    // Initialize Tab from Session
    const [settingsTab, setSettingsTab] = useState(() => {
        return sessionStorage.getItem('activeSettingsTab') || 'currentUser';
    });

    useEffect(() => {
        sessionStorage.setItem('activeSettingsTab', settingsTab);
    }, [settingsTab]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('code')) {
            setSettingsTab('integrations');
        }
    }, [location.search]);

    // doced-8f3a61c2 — the estimate page switch, read live from the company document (missing = off).
    const estimatePagesOn = isDocumentPageOn(companySettings, 'estimates');
    // taxlines5-a4c81e37 — Settings › Taxes (live). The convert buttons carry the source's "Charge tax on this
    // document" switch-off onto the new job / invoice, as the server's job → invoice paths do; {} unless Taxes and
    // exemptions are on for the company (every real company: nothing changes).
    const taxCodesDoc = useTaxCodesDoc(currentUserProfile?.organizationId);
    const carriedOffFor = (source) => carriedExemptionOffFields({ orgId: currentUserProfile?.organizationId, taxCodesDoc, source });
    // Once the page is open it stays open if the switch goes off meanwhile (like an open pop-up), so
    // nobody loses what they're typing; the next estimate they open uses the pop-up.
    const estimatePageLatchRef = useRef(false);

    const path = location.pathname;
    let activeView; 
    if (path.startsWith('/estimates/')) activeView = 'estimate-page'; // doced-8f3a61c2 — /estimates/new | /estimates/:ref
    else if (path.startsWith('/customers')) activeView = 'customers';
    else if (path.startsWith('/leads') || path.startsWith('/requests')) activeView = 'requests'; 
    else if (path.startsWith('/quotes')) activeView = 'quotes';
    else if (path.startsWith('/jobs/') && path.includes('/edit')) activeView = 'job-editor'; // D1 VERIFIER: r1-d1-jobeditor-route-7b3e9a04
    else if (path.startsWith('/jobs/new')) activeView = 'job-editor'; // D1 VERIFIER: r1-d1-jobeditor-route-7b3e9a04
    else if (path.startsWith('/jobs')) activeView = 'jobs';
    else if (path.startsWith('/recurring-invoices')) activeView = 'recurring-invoices'; // recinv-crmapp-path-1e9a4c57
    else if (path.startsWith('/invoices')) activeView = 'invoices';
    else if (path.startsWith('/timesheets')) activeView = 'timesheets';
    else if (path.startsWith('/calendar')) activeView = 'calendar';
    else if (path.startsWith('/reports')) activeView = 'reports';
    else if (path.startsWith('/email')) activeView = 'email';
    else if (path.startsWith('/flagged')) activeView = 'flagged'; // PHASE 1.6 VERIFIER: r1-16-web-crmapp-route-16a3f2b8
    else if (path.startsWith('/marketing')) activeView = 'marketing';
    else if (path.startsWith('/settings')) activeView = 'settings';
    else if (path.startsWith('/employees')) activeView = 'employees';
    else if (path.startsWith('/hiring')) activeView = 'hiring';
    else if (path.startsWith('/routes')) activeView = 'routes';
    else if (path.startsWith('/schedule')) activeView = 'schedule';
    else if (path.startsWith('/expenses')) activeView = 'expenses';
    else if (path === '/sops' || path.startsWith('/sops/')) activeView = 'sops'; // sopweb-bdb7afcd
    else activeView = 'home';
    
    useEffect(() => {
        if (!currentUserProfile?.organizationId) return;

        // jobsnew-5c9e3a17 — route segments that are NOT document ids. `/jobs/new`
        // is a real route (activeView='job-editor', see the path table above), but
        // this handler's only test was "is there a parts[2]?", so it took the
        // literal string "new" as a job id and went looking for a document called
        // "new". That lookup always missed. It was harmless while a miss only
        // console.warn'ed; once Seam 2 put an alert on the miss, every Add Job
        // raised "That job no longer exists".
        const RESERVED_ROUTE_SEGMENTS = ['new'];

        const handleDeepLinks = async () => {
            const parts = path.split('/');
            const resource = parts[1];
            const id = parts[2];

            // jobsnew-5c9e3a17 — never look a reserved segment up as a document id.
            if (id && !RESERVED_ROUTE_SEGMENTS.includes(id)) {
                const orgId = currentUserProfile.organizationId;

                if (resource === 'quotes' && viewingQuote?.id !== id) {
                    setLoadingDeepLink(true);
                    try {
                        const docRef = doc(db, `organizations/${orgId}/quotes`, id);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                            setViewingQuote({ id: docSnap.id, ...docSnap.data() });
                        }
                    } catch (e) {
                        console.error("Deep link error (quotes):", e);
                    } finally {
                        setLoadingDeepLink(false);
                    }
                }

                if (resource === 'invoices' && viewingInvoice?.id !== id) {
                    setLoadingDeepLink(true);
                    try {
                        const docRef = doc(db, `organizations/${orgId}/invoices`, id);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                            setViewingInvoice({ id: docSnap.id, ...docSnap.data() });
                        }
                    } catch (e) {
                        console.error("Deep link error (invoices):", e);
                    } finally {
                        setLoadingDeepLink(false);
                    }
                }

                // PHASE 1.4 VERIFIER: r1-9d4f7a82
                // Job/Follow-Up deep-link — mirrors handleSelectCalendarJob's
                // decision tree so the deep-link UX matches the kanban/calendar
                // click UX exactly.
                //
                // Decision rule (same as line 1270):
                //   - eventType is 'Job' (or missing/default) → JobQuickViewModal
                //     (techs see notes front-and-centre; canEdit prop gates
                //      destructive controls via PERMISSIONS.MANAGE_JOBS check)
                //   - eventType is 'Follow-Up' or any other non-Job → JobFormModal
                //     (which internally renders the appropriate view per
                //      eventType — e.g. the Edit Follow-Up modal techs can
                //      mark complete and close out)
                //
                // Guard: re-fire only when the target ID differs from BOTH
                // currently-open modals (editor and quickview). This allows
                // legitimate re-clicks across distinct jobs.
                // PHASE 1.4 VERIFIER: r1-9d4f7a82 (Batch 2.7) + r1-7a3e8b15 (Batch 2.9)
                //
                // Guard: skip only if the target job is ALREADY actively displayed
                // in a modal. A stale quickViewJob reference (modal closed, but
                // state value retained) must NOT block re-opening. Pre-2.9 the
                // guard `quickViewJob?.id !== id` rejected re-clicks even when
                // the modal was closed, producing the "click does nothing" UX
                // on the kanban after a previous open.
                const isAlreadyShowingThisJob =
                    (editingJob?.id === id && isJobModalOpen) ||
                    (quickViewJob?.id === id && isQuickViewModalOpen);

                // D1 VERIFIER: r1-d1-deeplink-skip-edit-3c7f9a52
                // Skip the QuickView-routing deep-link path for the D1 editor
                // route (/jobs/:id/edit). That URL is owned by the full-page
                // editor (activeView='job-editor') + its cold-load effect, which
                // populate editingJob directly. Without this guard, handleDeepLinks
                // also fetches the id and calls handleSelectCalendarJob, which can
                // open QuickView on top of the editor route (conflict) and double-
                // fetches. Bare /jobs/:id (notifications, profitability report) and
                // /jobs/:id?tab=... have no 'edit' segment, so they are unaffected
                // and keep their existing QuickView-or-editor routing.
                if (resource === 'jobs' && id && parts[3] !== 'edit' && !isAlreadyShowingThisJob) {
                    setLoadingDeepLink(true);
                    try {
                        const docRef = doc(db, `organizations/${orgId}/jobs`, id);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                            const jobData = { ...docSnap.data(), id: docSnap.id }; // s6costing-docid: doc id wins over a stale stored `id` field
                            console.info(`Deep link: opening job ${id}`, {
                                eventType:   jobData.eventType || '(none)',
                                modalRoute:  (jobData.eventType && jobData.eventType !== 'Job') ? 'editor' : 'quickview',
                            });
                            handleSelectCalendarJob(jobData);
                        } else {
                            console.warn(`Deep link: job ${id} not found in org ${orgId}`);
                            // s2-jobwp-9d4f2a61 — SEAM 2. The invoice's "Job #" is now a link
                            // (InvoiceDetailsView), so a deleted job is something a user can
                            // actually click. Silently doing nothing reads as a broken app;
                            // say what happened. alert() matches this view's existing idiom.
                            //
                            // jobsnew-5c9e3a17 — but ONLY for that click. Seam 2 put this alert
                            // on every miss, and the wording ("The invoice itself is unaffected")
                            // only makes sense to someone who came from an invoice. Any other
                            // miss — a stale notification, an old bookmark, a hand-typed URL —
                            // goes back to the silent console.warn it was before Seam 2.
                            // The flag is navigation state set by the Job # button itself, so
                            // the alert is tied to the one entry point whose copy it describes.
                            if (location.state?.fromInvoice) {
                                alert("That job no longer exists — it looks like it was deleted. The invoice itself is unaffected.");
                            }
                        }
                    } catch (e) {
                        console.error("Deep link error (jobs):", e);
                    } finally {
                        setLoadingDeepLink(false);
                    }
                }

                // PHASE 1.4 VERIFIER: r1-8e93a5f0
                // Customer deep-link — mirrors the quote/invoice pattern above.
                // Triggered by notification routing (note_flag → customer) and
                // by any direct navigation to /customers/:id.
                // Note: stale-state guard intentionally loose — we always fetch
                // if the resource is customers and selectedCustomer doesn't match,
                // even if selectedCustomer is null (initial state from cleanup).
                if (resource === 'customers' && id && selectedCustomer?.id !== id) {
                    setLoadingDeepLink(true);
                    try {
                        const docRef = doc(db, `organizations/${orgId}/customers`, id);
                        const docSnap = await getDoc(docRef);
                        if (docSnap.exists()) {
                            console.info(`Deep link: opening customer ${id}`);
                            setSelectedCustomer({ id: docSnap.id, ...docSnap.data() });
                        } else {
                            console.warn(`Deep link: customer ${id} not found in org ${orgId}`);
                        }
                    } catch (e) {
                        console.error("Deep link error (customers):", e);
                    } finally {
                        setLoadingDeepLink(false);
                    }
                }

                if ((resource === 'leads' || resource === 'requests') && initialEntityId !== id) {
                    setInitialEntityId(id);
                }
            } else {
                if (resource === 'quotes' && viewingQuote) setViewingQuote(null);
                if (resource === 'invoices' && viewingInvoice) setViewingInvoice(null);
            }
        };

        handleDeepLinks();

    }, [path, currentUserProfile]);

    // doced-8f3a61c2 — switch on: /quotes/:id (notifications, the calendar, an invoice's estimate link,
    // old bookmarks) opens the estimate page; the page swaps the id for the number in the address.
    useEffect(() => {
        if (!estimatePagesOn || !can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS)) return;
        const parts = path.split('/');
        if (parts[1] === 'quotes' && parts[2]) {
            navigate(`/estimates/${encodeURIComponent(parts[2])}${location.search}`, { replace: true, state: { ...(location.state || {}), quoteId: parts[2] } });
        }
    }, [path, estimatePagesOn]); // eslint-disable-line react-hooks/exhaustive-deps
    // A /quotes/:id lookup that finishes after that redirect must not cover the page.
    useEffect(() => {
        if (activeView === 'estimate-page' && viewingQuote) setViewingQuote(null);
        if (activeView !== 'estimate-page') estimatePageLatchRef.current = false;
    }, [activeView, viewingQuote]);

    useEffect(() => {
        const parts = path.split('/');
        const resource = parts[1];
        
        if (resource !== 'quotes') setViewingQuote(null);
        if (resource !== 'invoices') setViewingInvoice(null);
        if (resource !== 'recurring-invoices') setViewingSchedule(null); // recinv-crmapp-clear-9b2e4d18
        if (resource !== 'leads' && resource !== 'requests') setInitialEntityId(null); 
        
        if (activeView !== 'customers') setSelectedCustomer(null);
        if (activeView !== 'employees') {
            setIsEmployeeModalOpen(false); 
            setEditingEmployee(null);
        }
        
    }, [activeView, path]); 
    
    // calreturn-7b2e9d41 — restore the calendar's team filter instead of reseeding to
    // "only me" on every mount. That reseed is why the founder's selection vanished each
    // time the job editor unmounted and remounted this tree.
    //
    // First-time default is unchanged: [user.uid]. null (nothing stored) seeds to only-me;
    // a stored [] stays empty, because Clear all is a real choice. Stored ids are pruned
    // against the live employee list by the effect below.
    const calendarFilterPrunedRef = useRef(false);
    useEffect(() => {
        if (!user?.uid) return;
        calendarFilterPrunedRef.current = false;
        const stored = readCalendarTeamFilter(user.uid);
        setSelectedEmployees(stored === null ? [user.uid] : stored);
    }, [user?.uid]);

    // calreturn-7b2e9d41 — prune restored ids against the CURRENT employee list, once,
    // after that list first loads. A stored filter naming people who have since left the
    // company renders a blank calendar with no explanation of why. If pruning empties a
    // selection that WAS non-empty, fall back to only-me rather than showing nothing.
    // A selection that was already empty is left alone — see the null-vs-empty note above.
    useEffect(() => {
        if (calendarFilterPrunedRef.current) return;
        if (!user?.uid || users.length === 0) return;
        calendarFilterPrunedRef.current = true;
        setSelectedEmployees(prev => {
            if (prev.length === 0) return prev;
            const live = prev.filter(id => users.some(u => u.id === id));
            if (live.length === prev.length) return prev;
            return live.length > 0 ? live : [user.uid];
        });
    }, [users, user?.uid]);

    useEffect(() => {
        if (!user || !currentUserProfile?.organizationId) return;
        const orgId = currentUserProfile.organizationId;

        const userDocRef = doc(db, "users", user.uid);
        
        const unsubUser = onSnapshot(userDocRef, (doc) => {
            if (doc.exists()) {
                const data = doc.data();

                setIsGmailConnected(prev => {
                    const newVal = data.gmailConnected || false;
                    return prev === newVal ? prev : newVal;
                });
                setIsCalendarConnected(prev => {
                    const newVal = data.googleCalendarConnected || false;
                    return prev === newVal ? prev : newVal;
                });
                setIsOutlookConnected(prev => {
                    const newVal = data.microsoftConnected || false;
                    return prev === newVal ? prev : newVal;
                });
                setIsMsCalendarConnected(prev => {
                    const newVal = data.msCalendarConnected || false;
                    return prev === newVal ? prev : newVal;
                });
                setEmailProvider(prev => {
                    const newVal = data.emailProvider || null;
                    return prev === newVal ? prev : newVal;
                });

                const isConnected = data.emailProvider === 'google' ? data.gmailConnected : data.microsoftConnected;
                if (isConnected) {
                    const tokenField = data.emailProvider === 'google' ? 'gmailAccessToken' : 'microsoftAccessToken';
                    const expiryField = data.emailProvider === 'google' ? 'gmailTokenExpiresAt' : 'microsoftTokenExpiresAt';
                    
                    if (data[tokenField] && data[expiryField]) {
                        const newExpiresAt = data[expiryField].toDate();
                        
                        setEmailTokenExpiresAt(prev => {
                            const newTime = newExpiresAt ? newExpiresAt.getTime() : null;
                            const prevTime = prev ? prev.getTime() : null;
                            return prevTime === newTime ? prev : newExpiresAt;
                        });

                        if (new Date() < newExpiresAt) {
                            setEmailAccessToken(prev => {
                                const newVal = data[tokenField];
                                return prev === newVal ? prev : newVal;
                            });
                        }
                    }
                }
            }
        });

        // x6tokens-4b7e9c25 — X6 (#20): the Microsoft access token now lives in users/{uid}/private/
        // mailSession (readable by its owner only), not on the user record every coworker can list.
        // The block above still reads the old copy for a holder the server has not moved yet. No doc
        // or a refused read = no token here; EmailView then asks getMicrosoftAccessToken for one.
        const unsubMailSession = onSnapshot(doc(db, "users", user.uid, "private", "mailSession"), (snap) => {
            const data = snap.exists() ? snap.data() : null;
            const expiresAt = data?.microsoftTokenExpiresAt?.toDate ? data.microsoftTokenExpiresAt.toDate() : null;
            if (data?.microsoftAccessToken && expiresAt) {
                setEmailTokenExpiresAt(prev => (prev && prev.getTime() === expiresAt.getTime() ? prev : expiresAt));
                if (new Date() < expiresAt) setEmailAccessToken(prev => (prev === data.microsoftAccessToken ? prev : data.microsoftAccessToken));
            }
        }, () => { /* refused or offline: EmailView falls back to the callable */ });
        
        const unsubSettings = onSnapshot(doc(db, `organizations/${orgId}`), (d) => { if (d.exists()) setCompanySettings(d.data()); });
        
        const customersRef = collection(db, `organizations/${orgId}/customers`);
        // webcustname-7c4a1e92 — every customer (orderBy('name') left out records without `name`),
        // a missing name filled in memory, sorted here.
        const unsubCustomers = onSnapshot(customersRef, (snapshot) => {
            const customerData = snapshot.docs.map(doc => withCustomerName({ id: doc.id, ...doc.data() })).sort(compareCustomersByName);
            setCustomers(customerData || []);
        });
        
        const servicesRef = collection(db, `organizations/${orgId}/services`);
        const qServices = query(servicesRef, orderBy('name'));
        const unsubServices = onSnapshot(qServices, (snapshot) => {
            const serviceData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setServices(serviceData);
        });
        
        const usersRef = collection(db, 'users');
        const qUsers = query(
            usersRef, 
            where("organizationId", "==", orgId),
            where("status", "in", ["active", "Active"]) 
        );
        const unsubUsers = onSnapshot(qUsers, (snapshot) => {
            const userList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setUsers(userList); 
        });
        
        const resourcesRef = collection(db, `organizations/${orgId}/resources`);
        const qResources = query(resourcesRef, orderBy('name'));
        const unsubResources = onSnapshot(qResources, (snapshot) => {
            setResources(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        const jobsRef = collection(db, `organizations/${orgId}/jobs`);
        const unsubJobs = onSnapshot(jobsRef, (snapshot) => {
            // r3-rec-jobs-docwins-9b6c4e10 — spread first, then set id from doc.id last, so a
            // stale `id` FIELD in a job body can't shadow the real Firestore doc id. Mirrors the
            // safe read already used in JobManagementView (r1-rec-subid-docwins-c3a8e5f1). This is
            // the load-bearing jobs listener; a buggy only_this occurrence now resolves to its own
            // doc id instead of the template id, so it opens and suppresses its projected card.
            setJobs(snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        });

        return () => {
            unsubUser(); 
            unsubMailSession(); // x6tokens-4b7e9c25
            unsubSettings();
            unsubCustomers();
            unsubServices(); 
            unsubUsers();
            unsubResources();
            unsubJobs();
        };
    }, [user?.uid, currentUserProfile?.organizationId]);

    useEffect(() => {
        if (!quickViewJob || !currentUserProfile?.organizationId) return;
        const orgId = currentUserProfile.organizationId;
        const jobRef = doc(db, `organizations/${orgId}/jobs`, quickViewJob.id);
        
        const unsubscribe = onSnapshot(jobRef, (docSnapshot) => {
            if (docSnapshot.exists()) {
                setQuickViewJob({ ...docSnapshot.data(), id: docSnapshot.id }); // s6costing-docid: doc id wins over a stale stored `id` field
            } else {
                setIsQuickViewModalOpen(false);
            }
        });

        return () => unsubscribe();
    }, [quickViewJob?.id, currentUserProfile?.organizationId]);

    useEffect(() => {
        if (!user?.uid) return;
        const shiftsRef = collection(db, `users/${user.uid}/shifts`);
        // shiftactive-d8e4f6a2 — NO limit(1): must fetch ALL open shifts, then pick the
        // most-recently-STARTED one in JS. limit(1) with no orderBy returns an arbitrary
        // doc, and sorting a set Firestore already truncated to one is a silent no-op.
        const q = query(shiftsRef, where("shiftEnd", "==", null));
        // clkack-9c0d1e2f — includeMetadataChanges so the SERVER-ack snapshot
        // (hasPendingWrites === false) actually fires. The local latency-compensated
        // snapshot (~50ms, hasPendingWrites === true) must NOT release the clock guard,
        // or the button re-enables BEFORE the write settles and toggle-spam gets faster.
        const unsubscribe = onSnapshot(q, { includeMetadataChanges: true }, (snapshot) => {
            console.log('clkdbg-7b2e4f16 snap', 'size=' + snapshot.size, 'pendingWrites=' + snapshot.metadata.hasPendingWrites, 'fromCache=' + snapshot.metadata.fromCache, 'action=' + pendingActionRef.current); // clkdbg-7b2e4f16 TEMP — real snapshot values during a clock action
            const active = selectActiveOpenShift(snapshot.docs.map(d => ({ id: d.id, ...d.data() })));
            setActiveShift(active);
            const pending = pendingActionRef.current;
            if (pending && !snapshot.metadata.hasPendingWrites &&
                ((pending === 'in' && active) || (pending === 'out' && !active))) {
                console.log('clkdbg-7b2e4f16 RELEASING via listener', 'action=' + pending, 'size=' + snapshot.size, 'fromCache=' + snapshot.metadata.fromCache, 'pendingWrites=' + snapshot.metadata.hasPendingWrites); // clkdbg-7b2e4f16 TEMP — the snapshot that actually frees the guard
                releaseClock();
            }
        }, (error) => {
            // Listen died (rules read denial, dropped channel): free the guard now
            // rather than stranding the tech until the 8s backstop fires.
            console.error("Open-shift listener error:", error);
            releaseClock();
        });
        return () => unsubscribe();
    }, [user?.uid, releaseClock]);
    
    // calreturn-7b2e9d41 — persist on CHANGE, from the two handlers, rather than from an
    // effect watching selectedEmployees. An effect would run in the same commit as the
    // restore effect above, still holding the pre-restore [] — and would immediately
    // write that empty array back over the stored selection.
    const persistCalendarTeamFilter = useCallback((ids) => {
        if (!user?.uid) return;
        try {
            localStorage.setItem(
                CALENDAR_TEAM_FILTER_KEY_PREFIX + user.uid,
                JSON.stringify({ v: 1, ids })
            );
        } catch {
            // private mode / quota can throw — the filter still works, just no persistence
        }
    }, [user?.uid]);

    const handleEmployeeFilterChange = (employeeId) => {
        // Still a single-id toggle: the shape every other caller depends on is unchanged.
        const next = selectedEmployees.includes(employeeId)
            ? selectedEmployees.filter(id => id !== employeeId)
            : [...selectedEmployees, employeeId];
        setSelectedEmployees(next);
        persistCalendarTeamFilter(next); // calreturn-7b2e9d41
    };

    // calsel-6b2f9d34 — bulk setter for the calendar's Select all / Clear all.
    // Deliberately separate from handleEmployeeFilterChange rather than folded
    // into it: that one is a single-id toggle and every other caller depends on
    // that shape. Takes the whole next list so the caller owns the intent.
    const handleEmployeeFilterSetAll = (employeeIds) => {
        const next = Array.isArray(employeeIds) ? employeeIds : [];
        setSelectedEmployees(next);
        persistCalendarTeamFilter(next); // calreturn-7b2e9d41
    };

    const handleDeleteCustomer = async (customerId) => {
        const role = currentUserProfile?.role;
        if (role !== 'Admin' && role !== 'Manager' && role !== 'Owner/System Admin' && role !== 'Owner' && role !== 'System Admin') {
            alert("Permission Denied: Only Admins, Owners, and Managers can delete customers.");
            return;
        }

        try {
            const orgId = currentUserProfile.organizationId;
            
            const invoicesRef = collection(db, `organizations/${orgId}/invoices`);
            const jobsRef = collection(db, `organizations/${orgId}/jobs`);
            
            const invoiceQuery = query(invoicesRef, where("customerId", "==", customerId), limit(1));
            const jobQuery = query(jobsRef, where("clientId", "==", customerId), limit(1));

            const [invoiceSnap, jobSnap] = await Promise.all([
                getDocs(invoiceQuery),
                getDocs(jobQuery)
            ]);

            const hasRecords = !invoiceSnap.empty || !jobSnap.empty;

            if (hasRecords) {
                const confirmArchive = window.confirm(
                    "⚠️ Data Integrity Warning\n\n" +
                    "This customer has existing Invoices or Jobs. Deleting them permanently would corrupt your financial records.\n\n" +
                    "Standard practice is to ARCHIVE them instead.\n" +
                    "- They will be hidden from lists.\n" +
                    "- Historical invoices remain valid.\n" +
                    "- You can restore them from Settings > Archived Customers.\n\n" +
                    "Click OK to ARCHIVE this customer."
                );
                
                if (confirmArchive) {
                    await updateDoc(doc(db, `organizations/${orgId}/customers`, customerId), {
                        status: 'Archived',
                        archivedAt: serverTimestamp(),
                        archivedBy: user.uid
                    });
                    
                    setSelectedCustomer(null);
                    setEditingCustomer(null);
                    setIsCustomerModalOpen(false);
                    alert("Customer archived.");
                }
            } else {
                if (window.confirm("Are you sure you want to PERMANENTLY delete this customer? This cannot be undone.")) {
                    await deleteDoc(doc(db, `organizations/${orgId}/customers`, customerId));
                    
                    setSelectedCustomer(null);
                    setEditingCustomer(null);
                    setIsCustomerModalOpen(false);
                    
                    if (viewingQuote?.customerId === customerId) setViewingQuote(null);
                }
            }

        } catch (error) {
            console.error("Error managing customer deletion: ", error);
            alert("An error occurred.");
        }
    };

    const handleCreateQuoteFromRequest = async (request, customer) => { 
        if (!customer) { 
            console.error("Could not find customer to create quote for.");
            alert("Error: Could not find the associated customer for this request.");
            return;
        }

        let lineItems = undefined;

        if (request.templateId && currentUserProfile?.organizationId) {
            try {
                const templateSnap = await getDoc(
                    doc(db, `organizations/${currentUserProfile.organizationId}/jobTemplates`, request.templateId)
                );
                if (templateSnap.exists()) {
                    const template = templateSnap.data();
                    const durationMins = template.estimatedDuration || 60;
                    // lineidweb-9e4a2d17 — the one shared template function (target 'booking': Hour lines
                    // by the template line's own minutes; Tax Exempt tmplexempt-5c9d1f38 and the tax code
                    // carried) — exactly what this block built before — plus a fresh lineId per line.
                    lineItems = lineIds.templateLinesFor(template.lineItems, { target: 'booking', newId: lineIds.newLineId });
                }
            } catch (e) {
                console.error("Failed to load template for quote pre-fill:", e);
            }
        }

        const fromLead = {
            customer,
            title:     request.templateName || request.subject || 'Quote',
            notes:     request.description  || '',
            lineItems,
            requestId: request.id, // Seam 0 — rides into QuoteFormModal, stamped on create (change A)
        };
        // doced-8f3a61c2 — switch on: the same prefill opens the estimate page instead.
        if (estimatePagesOn) { openQuoteModal(fromLead); return; }
        setEditingQuote(fromLead);
        setIsQuoteModalOpen(true);
    };

    // ── Book Now ─────────────────────────────────────────────────────────────
    // Creates Quote + Pending Job from the booking template, sends quote email,
    // marks lead Converted. Called from RequestDetailModal after confirmation.
    const handleBookNow = async (request) => {
        const orgId = currentUserProfile?.organizationId;
        if (!orgId) return;

        const customer = customers.find(c => c.id === request.customerId);
        if (!customer) {
            throw new Error('CUSTOMER_NOT_FOUND');
        }

        if (!request.templateId) {
            throw new Error('NO_TEMPLATE');
        }

        let template;
        const snap = await getDoc(doc(db, `organizations/${orgId}/jobTemplates`, request.templateId));
        if (!snap.exists()) throw new Error('TEMPLATE_NOT_FOUND');
        template = { id: snap.id, ...snap.data() };

        const durationMins = template.estimatedDuration || 60;
        // lineidweb-9e4a2d17 — the one shared template function (target 'booking', the same one server
        // bookNow uses; booknowexempt-9b4e6c21's Tax Exempt tick is carried there) — exactly what this
        // block built before — plus a fresh lineId per line. The job below gets its own copies.
        // bnitem-4d7a2e95 — + the estimate builder's itemId per line (newItemId), which portal approval
        // (approveQuoteV2 §5) requires; exactly as server bookNow. The job copies carry the same itemIds.
        const lineItems = lineIds.templateLinesFor(template.lineItems, { target: 'booking', newId: lineIds.newLineId, newItemId: generateItemId });

        const subtotal  = lineItems.reduce((s, i) => s + ((i.quantity || 0) * (i.price || 0)), 0);
        const taxRate   = companySettings?.taxRate || 0;
        const taxAmount = lineItems.filter(i => !i.taxExempt).reduce((s, i) => s + ((i.quantity || 0) * (i.price || 0)), 0) * (taxRate / 100); // booknowexempt-9b4e6c21 -- exempt lines are not taxed
        const total     = subtotal + taxAmount;

        const customerDetails = {
            name: customer.name || '', email: customer.email || '',
            phone: customer.phone || '', address1: customer.address1 || '',
            address2: customer.address2 || '', city: customer.city || '',
            state: customer.state || '', zip: customer.zip || '',
            country: customer.country || '',
        };

        const expiryDate = new Date();
        // qvalid-crm-booknow-2a6e9d38 — Seam 2: validity length from the org setting
        // (quoteDefaults.validityDays; falls back to the old 30). Create-time only.
        expiryDate.setDate(expiryDate.getDate() + resolveQuoteValidityDays(companySettings?.quoteDefaults));

        // r1-p1-docterm-crm-stamp-7f4c1b96 — booking auto-quote: number prefix + docType from the org default, one resolve so they agree
        const bookingTerm = resolveDocTerminology(companySettings?.quoteTerminologyDefault);

        // 1. Create Quote
        const quoteRef = await addDoc(collection(db, `organizations/${orgId}/quotes`), {
            customerId: customer.id, customerName: customer.name, customerDetails,
            title: template.name, description: template.defaultNotes || '',
            notes: request.description || '', lineItems, subtotal, taxAmount, total,
            // qnumstrip-9d2f6b81 — Seam 2A: quoteNumber no longer stamped here; setQuoteNumberOnCreate assigns it. docType stays (the trigger reads it for the prefix).
            status: 'Sent',
            docType: bookingTerm.type,
            source: 'booking_page', requestId: request.id,
            createdAt: serverTimestamp(), updatedAt: serverTimestamp(),
            // lastact-w3 — operator clicked Book Now on an inbound lead. This is a
            // SECOND Book Now implementation alongside the bookNow callable
            // (lastact-f12); both create estimates, so both stamp.
            lastActivityAt: serverTimestamp(),
            expiresAt: expiryDate, createdBy: user.uid, salesPersonId: resolveCreateSalesPersonId(customer, user.uid),
        });
        const quoteId = quoteRef.id;

        // 2. Compute first available date using same logic as ⚡ First Open button
        const arrivalWindow = template.defaultWindow || 'allday';
        const jobStart = computeFirstAvailableDate(jobs, companySettings, durationMins, arrivalWindow);
        const awWin = getArrivalWindow(arrivalWindow, companySettings); // aw-seam4
        jobStart.setHours(awWin.startH, awWin.startM, 0, 0);
        const jobEnd = new Date(jobStart.getTime() + durationMins * 60000);
        const appointmentDate = jobStart.toLocaleDateString('en-US', {
            weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        });

        await addDoc(collection(db, `organizations/${orgId}/jobs`), {
            title: template.name, clientId: customer.id, clientName: customer.name,
            address: customer.address1 || '', startAt: jobStart, endAt: jobEnd,
            status: 'Pending', eventType: 'Job', lineItems: lineIds.copyLinesWithLineage(lineItems, lineIds.newLineId), invoiceTotal: total, // lineidweb-9e4a2d17 — the job's own line IDs, pointing back at the estimate's
            description: template.defaultNotes || '', quoteId, requestId: request.id,
            templateId: template.id, arrivalWindow,
            arrivalWindowSnapshot: buildArrivalWindowSnapshot(arrivalWindow, companySettings), // aw-seam4
            schedulingMode: 'window', recurrence: { frequency: 'Never' },
            jobCosting: { laborEntries: [] }, assignedTo: [],
            createdAt: serverTimestamp(), updatedAt: serverTimestamp(), createdBy: user.uid,
        });

        // 3. Send quote email
        let emailSent = true;
        try {
            await httpsCallable(functions, 'sendQuoteEmail')({ quoteId, appointmentDate });
        } catch (emailErr) {
            console.error("handleBookNow: quote email failed", emailErr);
            emailSent = false;
        }

        // 4. Mark lead Converted
        await updateDoc(doc(db, `organizations/${orgId}/requests`, request.id), {
            status: 'Converted', convertedAt: serverTimestamp(), quoteId,
        });

        return { success: true, quoteId, emailSent, customerName: customer.name, customerEmail: customer.email };
    };

    const openQuoteModal = (quote = null) => {
        // quotelock-3f7a2d91 -- mirrors openInvoiceModal (invlock-8c4e1b62). A Field
        // Technician lacks MANAGE_FINANCIALS, so neither creating nor editing a quote
        // through this modal is reachable for them. Closes the customer-profile
        // Estimates tab entry point, which had no gate of any kind, plus the quote
        // -details Edit button that tab leads to.
        if (!can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS)) return;
        // doced-8f3a61c2 — switch on: the full-page estimate instead of the pop-up. Switch off: unchanged.
        if (estimatePagesOn) { openEstimatePage(quote); return; }
        setEditingQuote(quote);
        setViewingQuote(null);
        setIsQuoteModalOpen(true);
    };

    // doced-8f3a61c2 — open the estimate page. A stored estimate opens in edit (?edit=1), by its id
    // (navigation state) so a shared number never shows the chooser. A new one (blank, or pre-filled
    // from a customer, a lead or a re-quote) gets the prefill held here in memory — not in the address
    // or browser history, since it can carry a whole customer record — so a reload of /estimates/new
    // starts blank (accepted in the plan). The customer pop-up, if open, is closed: the page replaces it.
    const [estimatePrefill, setEstimatePrefill] = useState(null); // { key, data }
    const openEstimatePage = (quote = null) => {
        const returnTo = window.location.pathname + window.location.search;
        setIsCustomerModalOpen(false);
        setEditingCustomer(null);
        if (quote?.id) {
            navigate(`${estimatePath(quote)}?edit=1`, { state: { quoteId: quote.id, returnTo } });
            return;
        }
        const key = quote ? `prefill-${Date.now()}` : null;
        setEstimatePrefill(quote ? { key, data: quote } : null);
        navigate('/estimates/new', { state: { returnTo, prefillKey: key } });
    };

    // qclose-3e8a5c17 — Seam 9b. When the edit form saves a status that CLOSES
    // an existing estimate (→ Approved or Declined), the estimate page it lands
    // on asks why — once the server's close record appears (the trigger writes
    // it seconds after the save). Only a status CHANGE counts: re-saving an
    // already-Approved estimate asks nothing. Purely after the fact — the
    // approve path and its deposit guards run exactly as before.
    const [awaitClosePrompt, setAwaitClosePrompt] = useState(null); // { quoteId, since }
    const closeQuoteModal = (updatedQuoteData = null) => {
        if (updatedQuoteData) {
            setViewingQuote(prev => ({ ...prev, ...updatedQuoteData }));
            const before = normalizeStatus(editingQuote?.status);
            const after = normalizeStatus(updatedQuoteData.status);
            const closing = [QUOTE_STATUSES.APPROVED, QUOTE_STATUSES.DECLINED];
            if (updatedQuoteData.id && editingQuote?.id && closing.includes(after) && before !== after) {
                setAwaitClosePrompt({ quoteId: updatedQuoteData.id, since: Date.now() });
            }
        }
        setEditingQuote(null);
        setIsQuoteModalOpen(false);
    };
    
    const openCustomerModal = async (customerOrId = null, initialTab = 'contact') => {
        let fullCustomerData = customerOrId;

        if (customerOrId && !customerOrId.name && customerOrId.id) {
            const found = customers.find(c => c.id === customerOrId.id);
            if (found) {
                fullCustomerData = found;
            } else {
                try {
                    const docRef = doc(db, `organizations/${currentUserProfile.organizationId}/customers`, customerOrId.id);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        fullCustomerData = { id: docSnap.id, ...docSnap.data() };
                    }
                } catch (e) {
                    console.error("Error fetching customer details:", e);
                }
            }
        }

        setEditingCustomer(fullCustomerData);
        setInitialCustomerModalTab(initialTab);
        setIsCustomerModalOpen(true);
    };

    const closeCustomerModal = () => {
        setEditingCustomer(null);
        setIsCustomerModalOpen(false);
    };
    
    const openEmployeeModal = (employee = null) => {
        setEditingEmployee(employee);
        setIsEmployeeModalOpen(true);
    };

    const closeEmployeeModal = () => {
        setEditingEmployee(null);
        setIsEmployeeModalOpen(false);
    };

    const handleComposeRequest = async (customer, subject = '', body = '') => {
        if (!customer || !customer.id) {
            // Called with no customer — plain compose with empty recipient
            const recipientEmail = typeof customer === 'string' ? customer : (customer?.email || '');
            setComposeState({ isOpen: true, recipient: recipientEmail, subject, body });
            navigate('/email');
            return;
        }

        try {
            const notesCollectionRef = collection(db, `organizations/${currentUserProfile.organizationId}/customers/${customer.id}/notes`);
            await addDoc(notesCollectionRef, {
                contactDate: serverTimestamp(),
                contactType: 'Email Sent',
                noteText: 'Direct email sent to customer from CRM.',
                status: customer.status, 
            });
        }   catch (error) {
                console.error("Failed to log email in contact history:", error);
        }

        setComposeState({ isOpen: true, recipient: customer.email, subject, body });
        navigate('/email'); 
    };

    const handleComposeClose = () => {
        setComposeState({ isOpen: false, recipient: '', subject: '', body: '' });
    };

    const handleConnectionChange = useCallback((status, token, expiresAt, provider) => {
        if (provider === 'google') {
            setIsGmailConnected(status);
        } else if (provider === 'microsoft') {
            setIsOutlookConnected(status);
        } else {
            setIsGmailConnected(false);
            setIsOutlookConnected(false);
        }
        setEmailAccessToken(token);
        setEmailTokenExpiresAt(expiresAt);
        setEmailProvider(provider);
    }, []); 

    // mailtok-2c7f9e51 — handleConnectMicrosoft was REMOVED here (2026-09-16). It opened a Firebase
    // Microsoft sign-in popup and wrote `result._tokenResponse.refreshToken` into
    // microsoftRefreshToken — but that is a FIREBASE AUTH refresh token, not a Microsoft Graph one,
    // so the server would have handed it to Microsoft's token endpoint and been rejected.
    //
    // It was already dead code: EmailView explicitly ignored the prop in favour of its own
    // server-side redirect flow, and IntegrationsPage never destructured it. Production agreed —
    // 0 users carried microsoftConnectedAt, the only field this function wrote.
    //
    // Deleted alongside the rules guard that now refuses any client write to a token field, rather
    // than shipping a rule that silently breaks a code path. The two LIVE connect paths are
    // unaffected: EmailView.handleConnectMicrosoft and IntegrationsPage.handleMicrosoftConnect.

    const handleUpdateJob = async (jobId, updatedInfo, collectionOverride = 'jobs') => {
        if (!currentUserProfile?.organizationId || !jobId) return;
        const orgId = currentUserProfile.organizationId;
        const jobDocRef = doc(db, `organizations/${orgId}/${collectionOverride}`, updatedInfo.id || jobId);
        try {
            await updateDoc(jobDocRef, updatedInfo);
        } catch (error) {
            console.error("Error updating job:", error);
        }
    };

    // Creates a one-off exception job doc when a projected recurring instance is dragged
    // calres3b-6e4a2f81 — `assignmentOverride` is optional and is supplied only by the
    // calendar's reassign-by-drag when a PROJECTED occurrence is dropped on someone
    // else. This function materialises the occurrence by spreading the template, which
    // copies its assignment verbatim, so the new assignee has to be applied over that
    // copy rather than written afterwards — a second write would land on a doc whose id
    // we do not have (the addDoc below is deliberately not awaited).
    const handleCreateRecurringException = async (job, start, end, assignmentOverride = null) => {
        if (!currentUserProfile?.organizationId) return;
        const orgId = currentUserProfile.organizationId;
        const templateId = job.recurringJobId || job.id;
        try {
            const { id, startAt, endAt, recurrence, createdAt, updatedAt, ...jobData } = job;
            const cleanJob = Object.fromEntries(Object.entries(jobData).filter(([, v]) => v !== undefined));
            const origDate = startAt?.toDate ? startAt.toDate() : new Date(startAt || start);

            // 1. Create the moved exception at the new date — fire and forget
            //    (Firestore commits locally immediately; don't await server ACK)
            addDoc(collection(db, `organizations/${orgId}/jobs`), {
                ...cleanJob,
                ...(assignmentOverride || {}),
                // lineidweb-9e4a2d17 — the new visit's lines are copies of the template's: own lineIds + sourceLineId
                ...(Array.isArray(cleanJob.lineItems) ? { lineItems: lineIds.copyLinesWithLineage(cleanJob.lineItems, lineIds.newLineId) } : {}),
                startAt: start,
                endAt: end,
                recurrence: { frequency: 'Never' },
                recurringJobId: templateId,
                recurringException: true,
                createdAt: serverTimestamp(),
                creatorId: currentUserProfile.id,
                updatedAt: serverTimestamp(),
            }).catch(err => console.error('Failed to save exception job:', err));

            // 2. Mark the original date as an exception on the template — this
            //    fires the recurringJobs snapshot immediately (local cache),
            //    removing the ghost projection in real-time
            const origDateStr = format(origDate, 'yyyy-MM-dd');
            await updateDoc(doc(db, `organizations/${orgId}/recurringJobs`, templateId), {
                exceptions: arrayUnion(origDateStr),
            });
        } catch (err) {
            console.error('Failed to create recurring exception:', err);
        }
    };

    // r3-reschedule-ghost-seam1 — SEAM 1 write-only exception recorder. When a
    // REAL materialized recurring instance is dragged to a different day (as an
    // ordinary event OR a per-crew appearance), CalendarView calls this with the
    // template id and the ORIGINAL slot day (already formatted local yyyy-MM-dd
    // by the caller). Mirrors handleCreateRecurringException's step 2 exactly,
    // but WITHOUT creating a new doc — the instance already exists and is just
    // being re-dated. An exception is unrecoverable, so the caller owns the
    // local-day formatting and the day-changed guard; this only writes.
    const handleRecordRecurringException = async (templateId, dateStr) => {
        if (!currentUserProfile?.organizationId || !templateId || !dateStr) return;
        const orgId = currentUserProfile.organizationId;
        try {
            await updateDoc(doc(db, `organizations/${orgId}/recurringJobs`, templateId), {
                exceptions: arrayUnion(dateStr),
            });
        } catch (err) {
            console.error('Failed to record recurring exception:', err);
        }
    };

    // Called by CalendarView after any drag/drop or resize move
    const handleJobMoved = async (oldDateStr, newDateStr, job) => {
        if (!currentUserProfile?.organizationId) return;
        const orgId = currentUserProfile.organizationId;
        const affectedDates = [...new Set([oldDateStr, newDateStr].filter(Boolean))];

        for (const dateStr of affectedDates) {
            // Check if a saved route exists for this date
            const crewId = job.routeGroupId;
            if (!crewId) continue;
            const routeId = `${dateStr}_${crewId}`;
            try {
                const routeSnap = await getDoc(doc(db, `organizations/${orgId}/savedRoutes`, routeId));
                if (routeSnap.exists()) {
                    const dateLabel = new Date(dateStr + 'T12:00:00').toLocaleDateString('en-CA', {
                        weekday: 'short', month: 'short', day: 'numeric'
                    });
                    const reopt = window.confirm(
                        `The saved route for ${dateLabel} has been affected by this change.\n\nWould you like to go to Routes to re-optimize?`
                    );
                    if (reopt) {
                        navigate(`/routes?date=${dateStr}`);
                        return;
                    }
                }
            } catch (e) {
                console.warn('Route check failed:', e);
            }
        }
    };
    
    const openJobEditorModal = async (jobOrInitialData = null) => {
        // D1 VERIFIER: r1-d1-opener-navigate-3f8c2b91
        // The editingJob-building logic below is UNCHANGED from pre-D1. D1 only
        // adds navigation to the routed full-page editor at the shared exit.
        // editingJob remains the in-memory source of truth (carries the
        // recurring _instance* overlay a URL cannot encode); the URL id is used
        // only for deep-link/refresh cold-load fallback.
        let editorTargetId = null; // null → /jobs/new ; an id → /jobs/${id}/edit
        if (jobOrInitialData && jobOrInitialData.recurringJobId) {
            const orgId = currentUserProfile.organizationId;
            const templateRef = doc(db, `organizations/${orgId}/recurringJobs`, jobOrInitialData.recurringJobId);
            const templateSnap = await getDoc(templateRef);
            if (templateSnap.exists()) {
                // Preserve the original instance ID and date so "edit this only"
                // can update the correct individual job doc.
                // r1-rec-opener-instidfix-b6f9d2c4
                // CRITICAL: a PROJECTED occurrence has no real job doc — its `id` is
                // the TEMPLATE id (calendar passes resource={...template}) or a
                // synthetic composite (jobs-list virtual rows). Passing that as
                // _instanceId made "edit this only" setDoc() to jobs/{templateId},
                // writing a real job doc AT the template's id and overwriting prior
                // edits (data loss). Only carry _instanceId when it is a genuine
                // instance doc id — i.e. NOT equal to the template id, and not a
                // composite virtual-row id. Otherwise null -> save takes the addDoc
                // path and creates a fresh, uniquely-id'd exception doc.
                const passedId = jobOrInitialData.id;
                const isRealInstanceId =
                    !!passedId &&
                    passedId !== templateSnap.id &&
                    !String(passedId).startsWith(`${templateSnap.id}_`);

                // SEAM 2 — r2-rec-opener-hydrate-instance-7f3c1a48
                // For a MATERIALIZED occurrence the clicked surface already handed us the
                // real instance's OWN doc id (calendar resource=job, list row=job doc).
                // Hydrate the form from THAT day's real job so the operator sees the day's
                // true crew/title/line-items/status/scheduling, and so "only this occurrence"
                // preserves those values instead of flattening them to the template's.
                //   - Keep id = TEMPLATE id: the save heuristics/3-way prompt key off it, and
                //     isEditingInstance must stay FALSE (see below), so nothing changes there.
                //   - Override recurrence with the TEMPLATE's rule: an instance carries
                //     recurrence {frequency:'Never'}; without this override the form would stop
                //     believing it's a series and the series-save prompt would vanish.
                //   - Strip the instance's OWN recurringJobId (== template id) so it can't land
                //     on jobToEdit and flip isEditingInstance true, which would wake a dead
                //     branch that writes a job doc at the template id (the data-loss trap the
                //     comments above warn about). The real instance id travels only in
                //     _instanceId, exactly as before.
                // A PROJECTED occurrence has no real instance (isRealInstanceId false) or the
                // instance getDoc misses -> fall back to template hydration exactly as before.
                let hydratedFromInstance = false;
                if (isRealInstanceId) {
                    const instanceRef = doc(db, `organizations/${orgId}/jobs`, passedId);
                    const instanceSnap = await getDoc(instanceRef);
                    if (instanceSnap.exists()) {
                        const { recurringJobId: _instanceRecurringJobId, ...instanceData } = instanceSnap.data();
                        setEditingJob({
                            id: templateSnap.id,
                            ...instanceData,
                            recurrence: templateSnap.data().recurrence,
                            // r2fix-rec-templateid-carry-5d1c9a72
                            // Carry the REAL series-template id explicitly. jobToEdit.id
                            // cannot be trusted here: a materialized instance stores its
                            // own doc id in an `id` field, which `...instanceData` spreads
                            // over the template id above, so jobToEdit.id becomes the
                            // instance's id. Every recurring save path reads _templateId
                            // for the template id instead of inferring it from jobToEdit.id.
                            _templateId: templateSnap.id,
                            _instanceId: passedId,
                            _instanceStartAt: jobOrInitialData.startAt,
                            _instanceEndAt: jobOrInitialData.endAt,
                        });
                        hydratedFromInstance = true;
                    }
                }
                if (!hydratedFromInstance) {
                    setEditingJob({
                        ...templateSnap.data(),
                        id: templateSnap.id, // s6costing-docid: doc id wins over a stale stored `id` field
                        // r2fix-rec-templateid-carry-5d1c9a72 — same explicit template id
                        // on the template/projected path so every save path resolves it
                        // uniformly (here it equals templateSnap.id already).
                        _templateId: templateSnap.id,
                        _instanceId: isRealInstanceId ? passedId : null,
                        _instanceStartAt: jobOrInitialData.startAt,
                        _instanceEndAt: jobOrInitialData.endAt,
                    });
                }
                editorTargetId = templateSnap.id;
            } else {
                console.error("Could not find the recurring job template to edit.");
                setEditingJob(jobOrInitialData);
                editorTargetId = jobOrInitialData?.id || null;
            }
        } else {
            setEditingJob(jobOrInitialData);
            editorTargetId = jobOrInitialData?.id || null;
        }
        setIsJobModalOpen(true);
        // calreturn-7b2e9d41 — record exactly where this editor was opened FROM, so save
        // and close can return there instead of guessing.
        //
        // Read from window.location, not the `location` hook: the calendar's search-result
        // click calls handleNavigate (which rewrites ?date=) immediately before reaching
        // here, and the hook still holds the pre-navigate render's value. history.pushState
        // is synchronous, so window.location is already correct.
        const returnTo = window.location.pathname + window.location.search;
        navigate(
            editorTargetId ? `/jobs/${editorTargetId}/edit` : '/jobs/new',
            { state: { returnTo } }
        );
    };

    // PHASE 4.5 VERIFIER: r1-p45-converttojob-2e8f4c91
    // Selective-approval filter: when the quote was partially approved,
    // only the approved line items carry forward to the job. Declined
    // items stay on the original quote (Phase 7 will add a "Re-quote
    // declined items" button to revive them). Backward compatible:
    // quotes without approvedItemIds (legacy or approved before
    // Phase 4) carry forward as before.
    const handleConvertToJob = (quote) => {
        // r1-p1-docterm-crm-cvtjob-8b3f6d21 — per-doc word for the job description; reads THIS quote's own docType (freeze rule)
        const { word: docWord } = resolveDocTerminology(quote?.docType);
        const allLineItems = quote.lineItems || [];
        const hasPartialApproval = Array.isArray(quote.approvedItemIds);
        const itemsForJob = hasPartialApproval
            ? allLineItems.filter(item => item.itemId && quote.approvedItemIds.includes(item.itemId))
            : allLineItems;

        // PHASE FU-QC VERIFIER: r1-fu-qc-9c4e2a86
        // Carry duration forward from quote to job. Priority:
        //   1. quote.estimatedDuration (set from template at applyTemplate time
        //      in QuoteFormModal — new behavior post-FU-QC).
        //   2. Sum quantities of Service line items as hours. Spatchy line
        //      items are typed Service (qty = hours of labor) or Material
        //      (qty = units). Material qty has no time meaning — skipped.
        //      Missing type defaults to Service (legacy data).
        //   3. Default 60 min.
        // The endAt is computed accordingly. JobFormModal already derives
        // jobDurationHours/Mins from (endAt - startAt) on load, so this is
        // sufficient — no need to pass duration fields explicitly.
        //
        // Phase 4.5: duration estimate now runs on the APPROVED subset
        // so declined-by-customer hours don't inflate the job timeline.
        const minsFromServiceLineItems = itemsForJob
            .filter(li => (li.type || 'Service') === 'Service')
            .reduce((sum, li) => sum + (Number(li.quantity || 0) * 60), 0);
        const estimateMins = (quote.estimatedDuration && quote.estimatedDuration > 0)
            ? quote.estimatedDuration
            : (minsFromServiceLineItems > 0 ? minsFromServiceLineItems : 60);

        const startAtForJob = new Date();
        const endAtForJob = new Date(startAtForJob.getTime() + estimateMins * 60 * 1000);

        // Phase 4.5: prefer server-truth approved total over recomputed sum
        // (preserves the exact tax that was on the original quote, including
        // any QB-derived blended rates).
        const computedTotalFromItems = itemsForJob.reduce((sum, item) => {
            return sum + (Number(item.quantity || 0) * Number(item.price || 0));
        }, 0);
        const jobInvoiceTotal = hasPartialApproval && quote.approvedTotal != null
            ? Number(quote.approvedTotal)
            : computedTotalFromItems;

        const jobData = {
            title: `${quote.title} (Job)`,
            clientId: quote.customerId,
            clientName: quote.customerName,
            // PROPERTIES v3 — carry the quote's service location onto the job. When the quote is
            // tied to a property, use its address; otherwise fall back to the customer's main address.
            address: (quote.propertyId && quote.serviceAddress)
                ? quote.serviceAddress
                : (quote.customerDetails
                    ? `${quote.customerDetails.address1 || ''} ${quote.customerDetails.city || ''}`.trim()
                    : ''),
            propertyId: quote.propertyId || null,
            propertyName: quote.propertyName || null,
            billTo: normalizeBillTo(quote.billTo), // billto-crm-cvtjob-3d9f7a12 -- the quote's bill-to survives conversion (null = main customer)
            startAt: startAtForJob,
            endAt: endAtForJob,
            status: 'Scheduled',
            description: `Converted from ${docWord} #${quote.quoteNumber}.\n\n${quote.notes || ''}`, // r1-p1-docterm-crm-cvtjob-8b3f6d21
            quoteId: quote.id,
            // lineidweb-9e4a2d17 — the mapping moved verbatim into the shared lineIds.jobLinesFromQuoteLines;
            // each job line now gets its own lineId and points back at the estimate's line.
            lineItems: lineIds.jobLinesFromQuoteLines(itemsForJob, lineIds.newLineId),
            invoiceTotal: jobInvoiceTotal,
            recurrence: { frequency: 'Never', endDate: null },
            eventType: 'Job',
            jobCosting: { laborEntries: [] } 
        };
    
        openJobEditorModal({ ...jobData, ...carriedOffFor(quote) }); // taxlines5-a4c81e37 — + the estimate's switch-off (Taxes on only)
    };

    // r1-p7-requote-handler-6d3f8a92 — Phase 7.2 Re-quote declined items.
    // Creates a NEW Draft quote containing ONLY the declined lines from a
    // partially-approved quote — makes the subtractive case revenue-
    // recoverable (the competitive moat). Reads the original; never mutates
    // it. Mirrors handleConvertToInvoice's customer fetch and applyTemplate's
    // two-pass itemId mint+remap. New quote is born Draft (onQuoteStatusChanged
    // is update-only — no trigger fires on creation); parentQuoteId links back
    // to the source (new field; nothing else reads it yet).
    const handleReQuoteDeclinedItems = async (quote) => {
        const declinedIds = Array.isArray(quote.declinedItemIds) ? quote.declinedItemIds : [];
        if (declinedIds.length === 0) {
            alert('This quote has no declined items to re-quote.');
            return;
        }

        // QuoteFormModal expects a full `customer` object (not split fields).
        // Fetch it, mirroring handleConvertToInvoice.
        let customer;
        try {
            const orgId = currentUserProfile.organizationId;
            const customerSnap = await getDoc(doc(db, `organizations/${orgId}/customers`, quote.customerId));
            if (!customerSnap.exists()) {
                alert('Could not find the customer for this quote.');
                return;
            }
            customer = { id: customerSnap.id, ...customerSnap.data() };
        } catch (err) {
            console.error('Re-quote: failed to load customer', err);
            alert('Could not load the customer for this quote.');
            return;
        }

        // Filter to the declined lines (by itemId).
        const declinedLines = (quote.lineItems || []).filter(
            li => li.itemId && declinedIds.includes(li.itemId)
        );

        // Two-pass itemId mint + parentItemId remap (mirrors applyTemplate).
        // Pass 1: fresh id per declined line, build old→new map.
        const oldToNewId = new Map();
        declinedLines.forEach(li => {
            if (li.itemId) oldToNewId.set(li.itemId, generateItemId());
        });
        // Pass 2: rebuild each line with the fresh itemId; remap parentItemId
        // only when the parent is ALSO declined, else null it (the parent was
        // approved and won't exist in this re-quote — avoid a dangling ref).
        const reQuotedLineItems = declinedLines.map(li => {
            const newItemId = oldToNewId.get(li.itemId);
            const remappedParent = (li.parentItemId && oldToNewId.has(li.parentItemId))
                ? oldToNewId.get(li.parentItemId)
                : null;
            return {
                name: li.name || '',
                description: li.description || '',
                quantity: Number(li.quantity) || 1,
                price: Number(li.price) || 0,
                type: li.type || 'Service',
                taxCodeId: li.taxCodeId || '',
                taxExempt: li.taxExempt || false,
                taxExemptionNumber: li.taxExemptionNumber || '',
                serviceId: li.serviceId || '',
                selectionType: li.selectionType || DEFAULT_SELECTION_TYPE,
                parentItemId: remappedParent,
                itemId: newItemId,
                ...lineIds.salesTaxFields(li), // taxlines-771ce983 — a Settings › Taxes code and its kept copy ride along
            };
        });

        // Open the standard new-quote editor with the declined lines pre-loaded.
        // Shape mirrors handleCreateQuoteFromRequest; parentQuoteId rides along
        // and persists via QuoteFormModal's {...quoteData} save (line ~449).
        const reQuote = {
            customer,
            title: `${quote.title || 'Quote'} — Re-quote`,
            notes: '',
            lineItems: lineIds.attachLineage(reQuotedLineItems, declinedLines, lineIds.newLineId), // lineidweb-9e4a2d17 — own lineIds, pointing back at the original estimate's lines
            parentQuoteId: quote.id,
            // PROPERTIES v3 — carry the original quote's service location so the re-quote pre-selects it.
            propertyId: quote.propertyId || null,
            propertyName: quote.propertyName || null,
            serviceAddress: quote.serviceAddress || null,
        };
        // doced-8f3a61c2 — switch on: the same prefill opens the estimate page instead.
        if (estimatePagesOn) { openQuoteModal(reQuote); return; }
        setEditingQuote(reQuote);
        setIsQuoteModalOpen(true);
    };

    const closeJobModal = () => {
        // D1 VERIFIER: r1-d1-closer-navback-9a2f4d17
        // Full-page editor: return to wherever the user came from (Decision B).
        // State clears kept as belt-and-suspenders during the conversion (they
        // also close the legacy overlay mount until it's removed in apply-step 6).
        // Cold-load guard: if there's no in-app history to return to (editor URL
        // opened/refreshed directly), fall back to the job list instead of
        // navigating out of the app.
        setEditingJob(null);
        setIsJobModalOpen(false);
        // calreturn-7b2e9d41 — prefer the origin openJobEditorModal recorded. This is what
        // puts the founder back on the same calendar day AND view after a save, which
        // navigate(-1) could not do once the view became URL state.
        //
        // Explicit beats the history pop for a reason beyond reliability: navigate(-1) can
        // move back, but it can never say WHERE it is going — so it cannot drive a label,
        // and after any in-editor navigation it lands somewhere else entirely.
        //
        // Falls through to the original behaviour whenever there is no recorded origin
        // (cold load, pasted URL, refresh), so every other entry point is unchanged.
        const returnTo = location.state?.returnTo;
        if (returnTo) {
            navigate(returnTo);
        } else if (window.history.length <= 1) {
            navigate('/jobs');
        } else {
            navigate(-1);
        }
    };

    // D1 VERIFIER: r1-d1-coldload-fetch-6b4e9c28
    // Cold-load fallback for the routed full-page editor. On a normal in-app
    // open, openJobEditorModal has already populated editingJob (including any
    // recurring _instance* overlay), so this effect no-ops. It ONLY fires when
    // we're on /jobs/:id/edit but editingJob is null — i.e. the page was
    // refreshed or the URL was pasted fresh, wiping in-memory state. It then
    // rehydrates editingJob from the plain saved job doc by id. It deliberately
    // does NOT run for /jobs/new (no id → blank form is correct) and must NOT
    // overwrite an existing editingJob (would clobber the recurring overlay).
    useEffect(() => {
        if (activeView !== 'job-editor') return;
        if (editingJob) return; // in-app path already set it — don't clobber
        const parts = location.pathname.split('/');
        // Expect ['', 'jobs', ':jobId', 'edit']; /jobs/new has no 'edit' segment.
        if (parts[1] !== 'jobs' || parts[3] !== 'edit') return;
        const jobId = parts[2];
        if (!jobId || !currentUserProfile?.organizationId) return;
        let cancelled = false;
        (async () => {
            try {
                const orgId = currentUserProfile.organizationId;
                const jobSnap = await getDoc(doc(db, `organizations/${orgId}/jobs`, jobId));
                if (cancelled) return;
                if (jobSnap.exists()) {
                    setEditingJob({ ...jobSnap.data(), id: jobSnap.id }); // s6costing-docid: doc id wins over a stale stored `id` field
                } else {
                    // D1 VERIFIER: r1-d1-coldload-calendar-redirect-8f4a2c19
                    // Not found in `jobs` most often means the URL carries a
                    // recurringJobs TEMPLATE id (recurring occurrences share the
                    // template id — see logged Direction-2 item). The specific
                    // occurrence can't be reconstructed from the URL alone (the
                    // _instance* overlay is ephemeral), so we degrade gracefully to
                    // the calendar rather than dumping the user into the Kanban
                    // board via /jobs. Also covers a genuinely deleted job.
                    console.warn(`Cold-load: job ${jobId} not in jobs collection (likely a recurring template id or deleted); redirecting to calendar.`);
                    navigate('/calendar');
                }
            } catch (e) {
                if (!cancelled) {
                    console.error("Cold-load job fetch failed:", e);
                    navigate('/calendar');
                }
            }
        })();
        return () => { cancelled = true; };
    }, [activeView, editingJob, location.pathname, currentUserProfile, navigate]);

    // CONVERT-FIX VERIFIER: r1-cvt-crmapp-viewjob-4c8e2a91
    // Opens the job a quote was converted into. Fetches the job doc by
    // convertedToJobId, then reuses the existing job editor modal. Mirrors
    // the mobile View Job path (navigate to JobDetail).
    const handleViewJob = async (quote) => {
        const jobId = quote?.convertedToJobId;
        if (!jobId) return;
        try {
            const orgId = currentUserProfile.organizationId;
            const jobSnap = await getDoc(doc(db, `organizations/${orgId}/jobs`, jobId));
            if (jobSnap.exists()) {
                openJobEditorModal({ ...jobSnap.data(), id: jobSnap.id }); // s6costing-docid: doc id wins over a stale stored `id` field
            } else {
                console.warn('handleViewJob: job not found', jobId);
            }
        } catch (err) {
            console.error('handleViewJob: failed to open job', err);
        }
    };
    
    const handleQuoteSelect = (quote) => {
        // doced-8f3a61c2 — switch on: the list opens the estimate page (a Draft opens straight into edit).
        if (estimatePagesOn && quote?.id && can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS)) {
            navigate(estimatePath(quote), { state: { quoteId: quote.id, returnTo: window.location.pathname + window.location.search } });
            return;
        }
        setViewingQuote(quote);
    };

    // CONVERT-FIX VERIFIER: r1-cvt-crmapp-livequote-2f9b7d41
    // Keep the open standalone quote (viewingQuote) live. Without this, the
    // quote object is frozen at click-time, so convertedToJobId — stamped
    // asynchronously by the onJobCreated backend trigger — never reaches the
    // open QuoteDetailsView and its "Convert to Job" button won't flip to
    // "View Job" until the user closes and reopens the quote. Subscribe to
    // the single quote doc while it's open; merge fresh data in. Mirrors the
    // single-doc onSnapshot pattern already used elsewhere in this file.
    useEffect(() => {
        const orgId = currentUserProfile?.organizationId;
        const quoteId = viewingQuote?.id;
        if (!orgId || !quoteId) return;
        const unsub = onSnapshot(
            doc(db, `organizations/${orgId}/quotes`, quoteId),
            (snap) => {
                if (!snap.exists()) return;
                const fresh = { id: snap.id, ...snap.data() };
                setViewingQuote(prev => {
                    // Only update the same quote that's open; ignore if the
                    // user already navigated to a different quote or closed it.
                    if (!prev || prev.id !== fresh.id) return prev;
                    // qsnooze-9f4c2e18 — REPLACE, do not merge.
                    //
                    // This used to be `{ ...prev, ...fresh }`, which cannot
                    // represent a DELETED field: a removed key is simply absent
                    // from the snapshot, so the spread kept the stale value
                    // forever. Seam 7 is the first feature that deletes a quote
                    // field (snoozedUntil / snoozeReason, cleared by "Wake now"
                    // and by the nightly elapsed-snooze sweep), and with the
                    // merge the strip went on saying "Snoozed until…" until the
                    // user closed and reopened the estimate.
                    //
                    // Replacing is safe because `fresh` IS the whole document
                    // and every other writer of viewingQuote seeds it from a
                    // Firestore snapshot too (this file's other call sites) —
                    // there are no client-only fields to preserve.
                    return fresh;
                });
            },
            (err) => { console.error('viewingQuote listener error:', err); }
        );
        return unsub;
    }, [viewingQuote?.id, currentUserProfile?.organizationId]);
    
    // PHASE 4.5 VERIFIER: r1-p45-createinvoice-5d3a8b76
    // Selective-approval filter: when source is a partially-approved
    // quote, only approved line items carry into the invoice. Declined
    // items stay on the original quote.
    //
    // Backward compatible: jobs (eventType === 'Job'), legacy quotes
    // without approvedItemIds, and quotes approved in full all behave
    // exactly as before — full lineItems list and recomputed totals
    // from settings.taxRate.
    //
    // For partially-approved quotes we prefer the server-computed
    // approvedSubtotal/approvedTaxAmount/approvedTotal, which were
    // computed at approval time using proportional scaling of the
    // ORIGINAL quote's tax. This preserves whatever blended QB rate
    // (or manual rate) was applied when the quote was created, even
    // if settings.taxRate has changed since.
    const createNewInvoiceFromSource = async (source, customer, settings, userId) => {
        // r5-b2b-labor-async-4f8a2c31: async so we can query this job's prior labor
        // lines (invoices where linkedJobId == source.id) for delta-from-immutable-
        // stamps idempotency (Increment 2 — web labor materializer).
        const isQuote = source.eventType !== 'Job';
        const hasPartialApproval = isQuote && Array.isArray(source.approvedItemIds);

        const allLineItems = source.lineItems || [];
        const sourceItems = hasPartialApproval
            ? allLineItems.filter(item => item.itemId && source.approvedItemIds.includes(item.itemId))
            : allLineItems;

        // lineidweb-9e4a2d17 — the mapping moved verbatim into the shared lineIds.invoiceLinesFromSourceLines;
        // each invoice line now gets its own lineId and points back at the source line. Labour lines
        // added below get theirs when the invoice editor saves (ensureLineIds).
        let lineItems = lineIds.invoiceLinesFromSourceLines(sourceItems, lineIds.newLineId); // r5-b2b-labor-let-9d1e6b74: was const; reassigned below when injecting labor

        // --- r5-b2b-labor-inject-2a7c9f18: Increment 2 — materialize tracked labor
        // as invoice line items, gated on the effective Switch 2. Job sources only
        // (quotes never enter this branch). Interim invoices hold back flat Service
        // fees; one 'Labor' line per person at their own billableRate; idempotency
        // via delta-from-immutable-stamps read off this job's existing invoices.
        const isJobSource = source.eventType === 'Job';
        // laborbill-one-rule-6c2a9e47 — the job's own labour-billing choice wins in BOTH directions
        // (founder decision 2026-10-04); "use org default" needs company tracking AND billing on.
        // Same rule + same line maths as the job editor's readout: src/utils/laborBilling.js.
        const billLabor = resolveBillLabor(source.billLaborToCustomer, settings?.automationSettings);
        if (isJobSource && billLabor) {
            const isFinal = source.status === 'Completed';
            try {
                // Prior high-water marks from THIS job's immutable invoice labor lines
                // (never a mutable job counter). Single-field equality → no index.
                const orgId = currentUserProfile.organizationId;
                const invSnap = await getDocs(query(
                    collection(db, `organizations/${orgId}/invoices`),
                    where('linkedJobId', '==', source.id)
                ));
                const priorMax = priorBilledFromInvoices(invSnap.docs.map(d => d.data()));

                // Interim only: drop flat Service fees (AFTER a successful read, so a
                // query failure degrades to the pre-Increment-2 flat behavior).
                if (!isFinal) lineItems = lineItems.filter(li => li.type !== 'Service');

                // One labor line per person for the positive delta of accrued clocked
                // hours since last billed, priced at that person's billableRate.
                const billableRateByUid = {};
                const nameByUid = {};
                users.forEach(u => { billableRateByUid[u.id] = u.billableRate; nameByUid[u.id] = u.name; });
                const { lines: laborLines } = computeLaborBilling({
                    laborEntries: source.jobCosting?.laborEntries || [],
                    billableRateByUid, nameByUid, priorBilledByUid: priorMax, billLabor,
                });
                lineItems = [...lineItems, ...laborLines];
            } catch (e) {
                console.error('Labor materialization skipped (prior-invoice query failed); invoice keeps flat lines, no labor added.', e);
                // lineItems left intact — safe pre-Increment-2 behavior; office can adjust.
            }
        }
    
        const customerDetails = {
            name: customer.name || 'N/A',
            company: customer.company || '',
            email: customer.email || '',
            phone: customer.phone || '',
            address: [customer.address1, customer.address2, `${customer.city || ''}, ${customer.state || ''} ${customer.zip || ''}`, customer.country]
                .filter(Boolean)
                .join('\n'),
        };
    
        // Computed totals (used when source has no server-truth approved* fields)
        const computedSubtotal = lineItems.reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.price || 0)), 0);
        const computedTaxableSubtotal = lineItems
            .filter(item => !item.taxExempt) 
            .reduce((acc, item) => acc + (Number(item.quantity || 0) * Number(item.price || 0)), 0);
        const taxRate = settings?.taxRate || 0;
        const computedTaxAmount = computedTaxableSubtotal * (taxRate / 100); 
        const computedTotal = computedSubtotal + computedTaxAmount;

        // Server-truth approved totals win when available (Phase 4 partial approvals).
        const subtotal = hasPartialApproval && source.approvedSubtotal != null
            ? Number(source.approvedSubtotal)
            : computedSubtotal;
        const taxAmount = hasPartialApproval && source.approvedTaxAmount != null
            ? Number(source.approvedTaxAmount)
            : computedTaxAmount;
        const total = hasPartialApproval && source.approvedTotal != null
            ? Number(source.approvedTotal)
            : computedTotal;
    
        const today = new Date();
        const dueDate = new Date(today);
        dueDate.setDate(today.getDate() + (settings.paymentTerms ?? 30)); // SEAM 2 — nullish: 0 = due on receipt
    
        // s2-jobwp-9d4f2a61 — SEAM 2. The job's own Work Performed is the record of what
        // the customer is told, so it is copied VERBATIM and the flatten below is skipped
        // — the tech already wrote the sentence; flattening their notes on top of it would
        // print it twice. trim() only tests emptiness, it never alters what is copied.
        // `source` may be a QUOTE on this path, hence the eventType guard. Empty, absent
        // or non-string — every job in the database today — falls through to the
        // unchanged expression below, byte for byte.
        const jobWorkPerformed = (source.eventType === 'Job'
            && typeof source.workPerformed === 'string'
            && source.workPerformed.trim() !== '')
            ? source.workPerformed
            : '';
        // legnotes9-6b4e8d12 — SEAM 9. Both of these used to fall back to flattening
        // source.techNotes[] — customer-facing entries into Work Performed, internal
        // ones into the invoice's Internal Notes. Seam 8 deleted that array from every
        // job, so `(undefined || []).filter().map().join()` was already '' on both
        // lines and the expressions already collapsed to exactly what they now say.
        const customerNotes = jobWorkPerformed || '';
        const internalNotes = '';

        return {
            title: source.title || 'New Invoice',
            customerId: customer.id,
            customerName: customer.name,
            customerDetails: customerDetails,
            lineItems: lineItems, 
            subtotal: subtotal,     
            taxAmount: taxAmount,   
            total: total,           
            status: 'Unpaid',
            createdAt: today,
            dueDate: dueDate,
            createdBy: userId,
            linkedQuoteId: source.eventType !== 'Job' ? (source.id || null) : null,
            // linkedquote-4c7a9e63 -- Seam 2d/4b: stamp the human-readable estimate
            // number at creation, mirroring linkedJobNumber below, so InvoiceDetailsView
            // can show "Estimate #X" without a lookup or backfill. Falls back to null
            // (not a fabricated label) when the quote has no number. Only helps invoices
            // created after this change, by decision.
            linkedQuoteNumber: source.eventType !== 'Job' ? (source.quoteNumber || null) : null,
            linkedJobId: source.eventType === 'Job' ? (source.id || null) : null,
            // jobnum-3e8c1f92 — WAS `source.id || 'Job'`, i.e. the job's internal Firestore
            // DOC ID, which InvoiceDetailsView then printed to the user under "Job #". On a
            // recurring visit that id is `job_<templateId>_<yyyyMMdd>` (~33 chars) and it
            // overflowed into the Due Date column. Now the real human job number, mirroring
            // linkedQuoteNumber directly above and batchCreateInvoices / completeJob.
            // Null, never a fabricated label: the display resolves or degrades on its own,
            // and 'Job' as a value would defeat that by looking like a real number.
            // Every job doc gets a jobNumber from setJobNumberOnCreate, recurring
            // occurrences included (verified in production: 11 of 11 on one series).
            linkedJobNumber: source.eventType === 'Job' ? (source.jobNumber || null) : null,
            workPerformed: customerNotes,
            notes: internalNotes,
            // PROPERTIES v3 — carry the service location from the source quote/job.
            // Quotes store the property address in `serviceAddress`; jobs store it in `address`.
            propertyId: source.propertyId || null,
            propertyName: source.propertyName || null,
            serviceAddress: source.propertyId ? (source.serviceAddress || source.address || null) : null,
            // billto-crm-invseed-7e4b2c98 -- unlike customerDetails (rebuilt fresh above),
            // the chosen bill-to is carried forward from the source quote/job.
            billTo: normalizeBillTo(source.billTo),
            ...carriedOffFor(source), // taxlines5-a4c81e37 — the source's switch-off (Taxes on only)
        };
    };

    // seamE-6c4a7f92 — the unchanged conversion tail, extracted so BOTH the
    // no-prior-invoice path and the confirmation modal's "Create another invoice"
    // run byte-for-byte the same seed-build + modal-open flow. Deposit crediting
    // (which happens later, server-side, on invoice save) is untouched.
    const proceedWithConversion = async (quote, customer) => {
        const newInvoiceData = await createNewInvoiceFromSource(quote, customer, companySettings, user.uid); // r5-b2b-labor-await-q-6e3b1d92
        openInvoiceModal(newInvoiceData);
    };

    const handleConvertToInvoice = async (quote) => {
        // seamE-6c4a7f92 — isConverting is now a REAL re-entrancy guard + button
        // spinner: it wraps the new async detection query below. finally clears it
        // on every exit (proceed, warn, or error), so it never sticks.
        if (isConverting) return;
        setIsConverting(true);
        try {
            let customer;
            try {
                const orgId = currentUserProfile.organizationId;
                const customerRef = doc(db, `organizations/${orgId}/customers`, quote.customerId);
                const customerSnap = await getDoc(customerRef);
                if (!customerSnap.exists()) {
                     alert("Error: Could not find the associated customer to create an invoice.");
                     return;
                }
                customer = { id: customerSnap.id, ...customerSnap.data() };
            } catch (e) {
                 alert("Error fetching customer data.");
                 return;
            }

            if (!quote || !customer || !currentUserProfile?.organizationId || !user?.uid) {
                alert("Error: Missing required data to convert quote.");
                return;
            }

            // seamE-6c4a7f92 — detect invoices already created from THIS estimate.
            // Single-field equality → Firestore auto-indexes it, no composite index.
            const orgId = currentUserProfile.organizationId;
            let priorSnap;
            try {
                priorSnap = await getDocs(query(
                    collection(db, `organizations/${orgId}/invoices`),
                    where('linkedQuoteId', '==', quote.id)
                ));
            } catch (e) {
                // Detection failed — degrade to the pre-Seam-E behavior (proceed with
                // no warning) rather than block a legitimate conversion on a read error.
                console.error('Prior-invoice detection query failed; proceeding without duplicate warning.', e);
                await proceedWithConversion(quote, customer);
                return;
            }

            // No prior invoice → first conversion is completely unaffected: proceed
            // straight to the modal, no dialog, no extra step.
            if (priorSnap.empty) {
                await proceedWithConversion(quote, customer);
                return;
            }

            // Prior invoice(s) exist → collect their numbers (short-id fallback for a
            // legacy invoice with no number) and detect a consumed deposit.
            const depositInvoiceId = quote.deposit?.appliedToInvoiceId || null;
            const priorNumbers = [];
            let depositInvoiceNumber = null;
            priorSnap.forEach(docSnap => {
                const data = docSnap.data();
                const num = data.invoiceNumber || docSnap.id.slice(0, 6);
                priorNumbers.push(num);
                if (depositInvoiceId && docSnap.id === depositInvoiceId) {
                    depositInvoiceNumber = num;
                }
            });
            const depositApplied = !!depositInvoiceId;
            const depositAmount = depositApplied
                ? (quote.deposit?.appliedAmount ?? quote.deposit?.amountResolved)
                : null;

            // Show the confirmation; do NOT proceed yet. Cancel leaves no state behind.
            setConvertWarning({
                quote,
                customer,
                priorNumbers,
                depositApplied,
                depositAmount,
                depositInvoiceNumber,
            });
        } finally {
            setIsConverting(false);
        }
    };
    
    const openInvoiceModal = (invoice = null) => {
        // invlock-8c4e1b62 -- defense in depth behind the InvoiceDetailsView Edit-button
        // gate: a Field Technician lacks MANAGE_FINANCIALS, so neither editing nor
        // creating an invoice through this modal is reachable for them. The legitimate
        // tech invoice path (completeJob, Admin SDK) does not go through here.
        if (!can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS)) return;
        // impro-3c8f1a57 -- defense in depth behind the hidden Edit button: an imported
        // invoice (importId / importedAt) is history and never opens in the editor.
        if (invoice?.id && isImportedInvoice(invoice)) return;
        setEditingInvoice(invoice);
        setViewingInvoice(null);
        setIsInvoiceModalOpen(true);
    };

    const closeInvoiceModal = (updatedInvoiceData = null, opts = null) => {
        if (updatedInvoiceData) {
            setViewingInvoice(prev => ({ ...prev, ...updatedInvoiceData }));
            // h1s6-8b2f4d19 — the editor's "Save & Record Payment": the invoice page opens the form.
            if (opts?.recordPayment && updatedInvoiceData.id) setRecordPaymentForId(updatedInvoiceData.id);
        }
        setEditingInvoice(null);
        setIsInvoiceModalOpen(false);
    };

    // recinvform-crmapp-open-9f3c2a71 — create (null) or edit (schedule doc).
    const openScheduleModal = (schedule = null) => {
        setEditingSchedule(schedule);
        setIsScheduleModalOpen(true);
    };
    const closeScheduleModal = (saved = false) => {
        // The list and detail views subscribe live via onSnapshot, so a save needs
        // no manual refresh. On an edit, drop the stale detail-view copy so its Back
        // target is the (fresh) list rather than a pre-edit snapshot.
        if (saved) setViewingSchedule(null);
        setEditingSchedule(null);
        setIsScheduleModalOpen(false);
    };
    
    const handleInvoiceSelect = (invoice) => {
        setViewingInvoice(invoice);
    };

    // jobinvguard-5e1b7c84 — WARN BEFORE INVOICING A JOB A SECOND TIME (founder decision 2026-10-04:
    // warn, don't block — staged billing stays possible). Same pattern as the estimate flow
    // (handleConvertToInvoice, seamE-6c4a7f92): look up the job's invoices first; none → straight to
    // the form exactly as before; some → "This job already has an invoice — create another?".
    // Both link fields are read (linkedJobId on every path; jobId on older completeJob invoices),
    // single-field equality each, so no index. A failed lookup degrades to no warning rather than
    // blocking a legitimate invoice (same choice as the estimate flow).
    const handleGenerateInvoiceFromJob = async (job) => {
        if (!job || !currentUserProfile?.organizationId || !user?.uid) {
            alert("Cannot generate invoice: missing required information.");
            return;
        }
        let prior = [];
        try {
            const orgId = currentUserProfile.organizationId;
            const invoicesRef = collection(db, `organizations/${orgId}/invoices`);
            const [byLinked, byJobId] = await Promise.all([
                getDocs(query(invoicesRef, where('linkedJobId', '==', job.id))),
                getDocs(query(invoicesRef, where('jobId', '==', job.id))),
            ]);
            prior = collectPriorJobInvoices({
                job,
                invoiceDocs: [...byLinked.docs, ...byJobId.docs].map(d => ({ id: d.id, ...d.data() })),
            });
        } catch (e) {
            console.error('Prior-invoice detection for this job failed; proceeding without the duplicate warning.', e);
        }
        if (prior.length > 0) {
            setJobInvoiceWarningState({ job, priorNumbers: prior.map(p => p.number) });
            return;
        }
        await proceedWithJobInvoice(job);
    };

    const proceedWithJobInvoice = async (job) => {
        let customer;
        try {
            const orgId = currentUserProfile.organizationId;
            const customerRef = doc(db, `organizations/${orgId}/customers`, job.clientId);
            const customerSnap = await getDoc(customerRef);
            if (!customerSnap.exists()) {
                 alert("Error: Could not find the associated customer for this job.");
                 return;
            }
            customer = { id: customerSnap.id, ...customerSnap.data() };
        } catch (e) {
             alert("Error fetching customer data for job invoice.");
             return;
        }

        if (!customer) {
            alert("Error: Could not find the associated customer for this job.");
            return;
        }

        const newInvoiceData = await createNewInvoiceFromSource(job, customer, companySettings, user.uid); // r5-b2b-labor-await-j-8c4f7a05
        // nolines-59a4771f — no line items, no invoice. Checked on the invoice DRAFT, not the job, so a
        // labour-billed job with tracked hours still opens the editor with its labour lines (Marcus,
        // 2026-10-29); only an invoice that would have nothing on it is refused. Blank rows don't count.
        if (!hasInvoiceableLines(newInvoiceData.lineItems)) {
            alert(NO_LINES_INVOICE_MESSAGE);
            return;
        }

        // r1-3f2-crm-fetch-4b8f1e63 — fetch this job's customer-facing note groups and
        // attach them to the invoice SEED so InvoiceFormModal can show the inclusion
        // picker (single job-to-invoice path; mirrors the batch flow in JobManagementView).
        // On fetch failure we attach NO groups: picker stays hidden, no inclusion fields
        // are written, and the backend includes everything — today's behaviour. noteGroups
        // rides on the seed only; the modal's New/Convert branch is an allowlist that drops
        // it, so it can never persist to Firestore.
        try {
            const orgId = currentUserProfile.organizationId;
            newInvoiceData.noteGroups = await fetchCustomerNoteGroups(db, orgId, [job]);
        } catch (err) {
            console.error('Note inclusion fetch failed; invoice will include all notes as today.', err);
        }

        closeJobModal();
        openInvoiceModal(newInvoiceData);
    };

    // jobtidy-4d8b1f63 — handleAddTechNote DELETED (was here).
    //
    // It was the last web writer of job.techNotes, called from exactly one place:
    // the legacy note composer in JobQuickViewModal, which this seam removed. With
    // no caller it was unreachable, and an unreachable writer of a legacy shape is
    // precisely the dead code this repo has been bitten by before.
    //
    // What it did, and where each part now lives:
    //   1. techNotes arrayUnion on the job -> Notes & Media writes a real doc in
    //      organizations/{orgId}/notes instead.
    //   2. client-side Follow-Up Job doc (sourceTechNoteAt) -> onNoteCreated creates
    //      it server-side (sourceNoteId) in one atomic batch, and attaches the note
    //      to the follow-up so the assignee can actually read it.
    //   3. customer-timeline paper-trail line -> NOT replaced. The only real loss.
    //      Logged in BACKLOG.md as a known gap to port into onNoteCreated.
    //   4. users/{uid}/notifications type 'tech_flag' -> onNoteCreated writes
    //      'note_flag', fanned to every flagReviewerIds reviewer. Flags raised on
    //      the legacy path never reached the review inbox at all.
    //
    // READERS OF ITS OUTPUT ARE UNAFFECTED. completeJob (server) and the two mobile
    // job screens still write techNotes, and every reader still renders it: both
    // read-only web lists, the invoice seed below, noteInclusions' hasLegacy, the
    // portal appointment merge, and three readers in functions/index.js.
    //
    // sourceTechNoteAt was written ONLY here and is read ONLY by JobFormModal's
    // Seam 3 provenance banner (noteleak-3a9f2c71). No NEW follow-up will carry it;
    // every EXISTING one still does, so that reader stays and is untouched.

    // ═══════════════════════════════════════════════════════════════════════
    // wpauthor-5d3f8a26 — WORK PERFORMED ATTRIBUTION, SEAM B (web).
    // ═══════════════════════════════════════════════════════════════════════
    // REPLACES handleSaveWorkPerformed (jobtidy-4d8b1f63), which wrote the whole
    // box as one field with no record of who wrote what. Work Performed is now a
    // list of authored entries under the job, and job.workPerformed is their
    // flattened mirror — the string every customer-facing surface still reads.
    //
    // EVERY WRITE IS ONE BATCH: the entry document and the recomputed mirror
    // commit together, so the customer text and the entries that produce it can
    // never be observed disagreeing.
    //
    // THE FLATTEN IS COMPUTED FROM A FRESH READ, not from the caller's live
    // snapshot. A colleague may have added an entry since this modal rendered;
    // flattening stale state would quietly drop their sentence off the invoice.
    // One extra read per save is the right price for that.
    //
    // NO NEW GATE IS INVENTED HERE. firestore.rules polices the entries per
    // document — you may only ever create one as yourself (authorId ==
    // request.auth.uid), you may edit your own, and isOffice() (Office Staff plus
    // Admin/Manager/Owner) may edit anyone's. See the workPerformedEntries block
    // and rules tests WPA1-WPA12.
    // wpauthor-5d3f8a26 — SEAM E. THE WEB APP NO LONGER WRITES WORK PERFORMED.
    //
    // These three handlers used to read the entries, apply the change and write
    // both the entry and the recomputed mirror from here. That is what destroyed
    // a job's authorship on 2026-09-23: Seam D made the reconcile callable a
    // SECOND writer of the mirror, and a client has no read-your-writes guarantee
    // for a write it did not make. The follow-up read missed the server's write by
    // 214 ms, the client's flatten overwrote the correct mirror, and the next
    // operation's reconcile buried every authored entry under one unattributed
    // block. Nothing showed on screen, because the UI renders the ENTRIES.
    //
    // One writer, one transaction. writeWorkPerformedEntry does the reconcile, the
    // operation and the mirror together server-side; firestore.rules now refuses
    // all client writes to workPerformedEntries, so this is the only door.
    //
    // AUTHORSHIP IS NO LONGER SENT FROM HERE. The server takes it from
    // request.auth.uid and the caller's own user doc. A client-supplied author was
    // always the wrong shape for a feature about who wrote what.
    //
    // The UI updates from the useWorkPerformedEntries listener, so there is
    // nothing to apply locally and nothing to keep in sync.
    const writeWorkPerformedEntry = (payload) =>
        httpsCallable(functions, 'writeWorkPerformedEntry')(payload);

    // sourceNoteId records that this entry came from a promoted note. The entry's
    // AUTHOR is the promoter, not the note's writer: promoting exists so the
    // reviewer can reword the text before it reaches the customer, so attributing
    // it to the original author would put their name on sentences they may not
    // have written. The note keeps its own author and this id links the two.
    const handleAddWorkPerformedEntry = async (jobId, text, { sourceNoteId = null } = {}) => {
        const trimmed = (text || '').trim();
        if (!trimmed) return;
        await writeWorkPerformedEntry({ jobId, op: 'add', text: trimmed, sourceNoteId });
    };

    // An edit NEVER touches authorId or authorName — the server refuses to, and
    // the byline shows "<author> · edited by <editor>" so a manager rewriting a
    // tech's words cannot leave the tech's name standing alone over sentences the
    // tech did not write. That is the failure this seam prevents.
    const handleEditWorkPerformedEntry = async (jobId, entryId, text) => {
        const trimmed = (text || '').trim();
        if (!trimmed) return;
        await writeWorkPerformedEntry({ jobId, op: 'edit', entryId, text: trimmed });
    };

    // HIDE, NEVER ERASE. The entries are server-write-only now and the rules
    // refuse a delete outright, so removal is the server setting removed:true.
    // The entry leaves the customer's invoice at once (the flatten skips removed
    // entries) and stays visible internally with its author intact — if the
    // person who wrote a wrong diagnosis could delete it, the argument this seam
    // exists to settle would be unsettleable.
    const handleRemoveWorkPerformedEntry = async (jobId, entryId) => {
        await writeWorkPerformedEntry({ jobId, op: 'remove', entryId });
    };

    const handleAddTechLineItem = async (jobId, item) => {
        if (!currentUserProfile?.organizationId) return;
        const orgId = currentUserProfile.organizationId;
        const jobRef = doc(db, `organizations/${orgId}/jobs`, jobId);
        const jobSnap = await getDoc(jobRef);
        const existing = jobSnap.data()?.lineItems || [];
        const newItem = {
            name: item.name,
            description: '',
            quantity: Number(item.quantity) || 1,
            price: Number(item.price) || 0,
            type: 'Service',
            addedByTech: true,
            addedByName: currentUserProfile.name || 'Technician',
            addedAt: new Date().toISOString(),
            // taxlines5-a4c81e37 — Settings › Taxes ON only: the company default code, and "Added in the field —
            // check tax" when the person can't pick tax (Field Technician, Lead Hand). {} for every other company.
            ...onSiteLineTaxFields({ orgId, taxCodesDoc, companySettings, role: currentUserProfile.role, atMs: Date.now() }),
        };
        // lineidweb-9e4a2d17 — the new line gets its own lineId; the job's other lines get theirs if missing
        await updateDoc(jobRef, { lineItems: lineIds.ensureLineIds([...existing, lineIds.newLine(newItem, lineIds.newLineId)], lineIds.newLineId) });
    };

    const handleApproveTimesheet = async (timesheetData) => {
        if (!currentUserProfile?.organizationId || !user?.uid) {
            alert("Cannot approve timesheet: missing user or organization information.");
            return;
        }
        const orgId = currentUserProfile.organizationId;
        const weekStartDateString = format(timesheetData.weekStart, 'yyyy-MM-dd');
        const timesheetId = `${timesheetData.userId}_${weekStartDateString}`;
        const timesheetRef = doc(db, `organizations/${orgId}/timesheets`, timesheetId);
        const dataToSave = {
            ...timesheetData,
            status: 'Approved',
            approvedBy: user.uid,
            approvedAt: serverTimestamp(),
        };
        try {
            await setDoc(timesheetRef, dataToSave, { merge: true });
            alert(`${timesheetData.userName}'s timesheet for the week of ${weekStartDateString} has been approved.`);
        } catch (error) {
            console.error("Error approving timesheet:", error);
            alert("An error occurred while approving the timesheet.");
        }
    };

    const handleSelectCalendarJob = (job) => {
        // PHASE FU-QV VERIFIER: r1-fu-qv-8d3c5a92
        // Universal job/event click routing. The single decision point for
        // whether to open QuickView (operational) vs JobFormModal (full editor).
        //
        // Rules:
        //   1. Non-Job events (Appointment, Phone Appointment, Follow-Up)
        //      always open in the full editor — no quick-action surface needed.
        //   2. Jobs in Scheduled or In Progress: open QuickView. These are the
        //      "active operational" states where a tech needs to act now (start,
        //      navigate, complete) more often than edit.
        //   3. Jobs in any other status (Pending, Completed, Canceled): open
        //      the full editor. Pending needs setup, Completed needs review,
        //      Canceled needs context — none benefit from the QuickView surface.
        //
        // This is the universal router — every operational entry point (kanban,
        // calendar, list view, dispatch, customer profile, timesheets,
        // deep-links) routes through here.
        if (job.eventType && job.eventType !== 'Job') {
            openJobEditorModal(job);
            return;
        }
        const status = job.status;
        if (status === 'Scheduled' || status === 'In Progress') {
            setQuickViewJob(job);
            setIsQuickViewModalOpen(true);
            return;
        }
        openJobEditorModal(job);
    };

    // Returns the correct hourly cost rate for a user profile,
    // handling both Hourly and Salary compensation types.
    

    

    // webpunch-6c4a9e21 — web punch-in now does what the phone's has always done (spatchy-mobile
    // useJobPunch.doPunchIn): ONE save writes the job punch AND the person's pointer
    // users/{uid}.activeJobPunch. Before, the web wrote only the punch, so the phone could not see it:
    // no "job timer running" banner, no one-job-at-a-time guard, and the phone's break / clock-out
    // did not close it (it kept counting). The pointer is cleared by punchOutJob / completeJob.
    // One open punch per person: a punch already open on ANOTHER job (from either app — read from
    // the jobs this page already holds, so no extra reads) is refused with the phone's wording.
    const handleStartTimer = async (jobId) => {
        const orgId = currentUserProfile.organizationId;
        const jobRef = doc(db, `organizations/${orgId}/jobs`, jobId);
        const openElsewhere = (jobs || []).find((j) => j.id !== jobId
            && (j.timePunches || []).some((p) => p && p.userId === user.uid && !p.punchOut));
        if (openElsewhere) {
            alert(`You're already punched in to "${openElsewhere.title || 'another job'}"${openElsewhere.jobNumber ? ` (#${openElsewhere.jobNumber})` : ''}. You can only be punched in to one job at a time — punch out of it first.`);
            return;
        }
        const thisJob = (jobs || []).find((j) => j.id === jobId);
        try {
            const punchInAt = new Date();
            const newPunch = {
                userId: user.uid,
                userName: currentUserProfile.name,
                punchIn: punchInAt,
                punchOut: null,
                hours: null,
            };
            const batch = writeBatch(db);
            batch.update(jobRef, {
                status: 'In Progress',
                timePunches: arrayUnion(newPunch),
            });
            batch.update(doc(db, 'users', user.uid), {
                activeJobPunch: {
                    jobId,
                    jobTitle: thisJob?.title || 'a job',
                    appearanceId: null,
                    crewGroupId: null,
                    punchIn: punchInAt,
                },
            });
            await batch.commit();
        } catch (error) {
            console.error("Error starting timer:", error);
            alert('Could not start the job timer. Please try again.');
        }
    };

    // r6-b2a-webpunch-route-4f8c1e29 — B2a Seam 3 (redone): web punch-OFF is now server-authoritative.
    // Was a browser-side close/sum/rate/upsert that resolved cost from the loaded profile — fragile
    // (empty profile -> rate 0) and shipped comp to the client. Now calls the punchOutJob cloud
    // function (already live, mobile's path), which closes the open punch, sums sessions, resolves
    // the labor-COST rate SERVER-SIDE from the tech's fresh user doc, and upserts the laborEntries
    // row atomically. punchInTime is unused (kept for the QuickView call signature) — the server
    // finds the open punch itself. The job onSnapshot re-derives the QuickView clock on the write.
    const handleStopTimer = async (jobId, punchInTime) => {
        if (!currentUserProfile?.organizationId) {
            alert("Could not find your user profile to log hours.");
            return;
        }
        const orgId = currentUserProfile.organizationId;
        try {
            await httpsCallable(functions, 'punchOutJob')({ orgId, jobId });
        } catch (error) {
            console.error("Error stopping timer and logging hours:", error);
        }
    };

    const handleCompleteJob = async (jobId, options = {}) => {
        const orgId = currentUserProfile.organizationId;
        const jobRef = doc(db, `organizations/${orgId}/jobs`, jobId);
        try {
            const jobSnap = await getDoc(jobRef);
            if (!jobSnap.exists()) return false; // chklstweb-3a7f1c58
            const jobData = jobSnap.data();

            const crewsTotal = jobData.crewsTotal || 0;
            const isMultiCrew = crewsTotal > 1;

            if (isMultiCrew && !options.managerOverride) {
                // Show confirmation — manager override path (web app = manager/owner context)
                const crewNames = (jobData.crews || [])
                    .map(c => c.crewGroupName)
                    .filter(Boolean)
                    .join(', ');
                const confirmed = window.confirm(
                    `"${jobData.title}" is assigned to multiple crews (${crewNames}).

Mark all crew portions as complete and close this job?`
                );
                if (!confirmed) return false; // chklstweb-3a7f1c58
            }

            const crewsCompleted = crewsTotal > 0 ? crewsTotal : 0;
            const updatedCrews = isMultiCrew
                ? (jobData.crews || []).map(crew => ({
                    ...crew,
                    completedAt: crew.completedAt || new Date(),
                    completedBy: crew.completedBy || currentUserProfile.id,
                    managerOverride: !crew.completedAt, // flag crews that weren't self-completed
                  }))
                : jobData.crews;

            await updateDoc(jobRef, {
                status: 'Completed',
                completedAt: new Date(),
                ...(isMultiCrew ? {
                    crewsCompleted,
                    crews: updatedCrews,
                } : {}),
            });
        } catch (error) {
            console.error("Error completing job:", error);
            // chklstweb-3a7f1c58 — rethrow so the pop-up shows the refusal and stays open
            // (it used to close as if the job had completed).
            throw error;
        }
    };
    
    const handleUpdateResources = async (jobId, updatedResources) => {
        if (!currentUserProfile?.organizationId) return;
        const jobRef = doc(db, `organizations/${currentUserProfile.organizationId}/jobs`, jobId);
        try {
            await updateDoc(jobRef, { assignedResources: updatedResources });
        } catch (error) {
            console.error("Error updating resources:", error);
        }
    };

    const handleEditFromQuickView = (job) => {
        // D1 VERIFIER: r1-d1-quickview-handoff-4f2c8b91
        // Post-D1: the editor is a routed full-page view, no longer a sibling
        // of JobQuickViewModal in the render tree — so the old duplicate-key
        // collision class (retired guard r1-fu-bug-9e3a5c81) can no longer
        // occur; navigating to /jobs/:id/edit unmounts the view QuickView lives
        // in. openJobEditorModal now navigates there. We still clear QuickView
        // state here for a clean handoff and, importantly, to tear down the
        // stale onSnapshot listener (the effect keyed on quickViewJob?.id) that
        // would otherwise keep firing setQuickViewJob after we've moved on.
        setIsQuickViewModalOpen(false);
        setQuickViewJob(null);
        openJobEditorModal(job);
    };

    // clkstale-a5f0d7e2 — stale-shift self-report helpers. Defined ABOVE the clock
    // handlers (no use-before-define). The prompt owns time entry + validation;
    // these own the Firestore writes and the shipped-guard lifecycle.

    // The user's NEXT shift after `afterStart`, if any — bounds the self-reported
    // end (validation rule c) so an old orphan can't be stamped through later
    // shifts. Single-field range+order → auto-indexed, no composite index.
    const getNextShiftStart = async (uid, afterStart) => {
        if (!afterStart) return null;
        try {
            const snap = await getDocs(query(
                collection(db, `users/${uid}/shifts`),
                where('shiftStart', '>', afterStart),
                orderBy('shiftStart', 'asc'),
                limit(1),
            ));
            if (snap.empty) return null;
            return snap.docs[0].data().shiftStart || null;
        } catch (e) {
            console.error('clkstale-a5f0d7e2 next-shift lookup failed:', e);
            return null; // fail open — rules (a)/(b) still bound the entered time
        }
    };

    const openShiftPrompt = (data) => {
        shiftPromptOpenRef.current = true; // synchronous gate — blocks the clock handlers
        setShiftPromptData(data);
        setShiftPromptOpen(true);
    };

    const cancelShiftPrompt = () => {
        // Nothing written. The orphan stays open; a clock-in stays blocked until resolved.
        shiftPromptOpenRef.current = false;
        setShiftPromptOpen(false);
        setShiftPromptData(null);
    };

    // Called by the prompt with an already-validated `enteredMs`. Arms the shipped
    // guard HERE (never while the modal was open) and writes exactly the six
    // whitelisted fields, then (clock-in mode only) creates the new shift.
    const submitSelfReport = async (enteredMs) => {
        const data = shiftPromptData;
        if (!data || !user?.uid) return;
        const { mode, shift } = data;
        clockBusyRef.current = true;
        setClockBusy(true);
        // Final state we hold for: clock-in ends WITH an open shift (the new one),
        // clock-out ends with none. The listener releases on the matching server-ack.
        pendingActionRef.current = (mode === 'clockin') ? 'in' : 'out';
        clockFallbackRef.current = setTimeout(releaseClock, 8000);
        try {
            const ref = doc(db, `users/${user.uid}/shifts`, shift.id);
            await updateDoc(ref, buildSelfReportedEndUpdate(shift.shiftStart, enteredMs, user.uid));
            if (mode === 'clockin') {
                // Two sequential writes (documented, benign if the second fails):
                // close the old shift, THEN start the new one.
                await addDoc(collection(db, `users/${user.uid}/shifts`), {
                    shiftStart: serverTimestamp(),
                    shiftEnd: null,
                    organizationId: currentUserProfile.organizationId,
                    userId: user.uid,
                    userName: currentUserProfile.name,
                });
            }
            // Success — tear down the prompt; the guard releases on server-ack.
            shiftPromptOpenRef.current = false;
            setShiftPromptOpen(false);
            setShiftPromptData(null);
        } catch (error) {
            console.error('clkstale-a5f0d7e2 self-reported clock-out failed:', error);
            releaseClock();  // write failed — free the guard, keep the prompt open
            throw error;     // prompt surfaces the failure and re-enables its buttons
        }
    };

    const handleClockIn = async () => {
        if (!user?.uid) return;
        if (clockBusyRef.current || shiftPromptOpenRef.current) return; // clkin-3a4b5c6d + clkstale-a5f0d7e2 — re-entry guard incl. an open prompt
        // clkstale-a5f0d7e2 — arm the synchronous lock + 8s backstop UP FRONT. The
        // authoritative pre-read below is async, so a double-tap during it must be
        // blocked (else two reads both see 'none' and create two open shifts). Every
        // early-return frees the lock; the backstop prevents a hung read locking forever.
        clockBusyRef.current = true;
        setClockBusy(true);
        clockFallbackRef.current = setTimeout(releaseClock, 8000);

        // Authoritative read (NOT the listener): getDocs metadata distinguishes a
        // not-yet-resolved local serverTimestamp (adopt) from a corrupt server doc
        // that has lost its shiftStart (promptStale — a human must state the time).
        let openShifts = null;
        try {
            const snap = await getDocs(query(collection(db, `users/${user.uid}/shifts`), where('shiftEnd', '==', null)));
            openShifts = snap.docs.map(d => ({ id: d.id, ...d.data(), __pendingWrites: d.metadata.hasPendingWrites }));
        } catch (e) {
            console.error('clkstale-a5f0d7e2 clock-in pre-read failed:', e); // read failed — fall through to a normal create (no regression)
        }

        if (openShifts) {
            const newest = selectActiveOpenShift(openShifts);
            const decision = classifyOpenShift(newest, Date.now(), newest?.__pendingWrites ?? false);
            if (decision === 'adopt') {
                // A live in-progress (or just-created) shift already exists — adopt it,
                // create nothing, no prompt. Strip the local-only metadata flag.
                const { __pendingWrites, ...clean } = newest; // eslint-disable-line no-unused-vars
                setActiveShift(clean);
                releaseClock();
                return;
            }
            if (decision === 'promptStale') {
                // Transition the lock from the clock guard to the prompt gate BEFORE any
                // await, so there is no unlocked window; clear the 8s timer so it can't
                // fire while the modal waits on the human.
                shiftPromptOpenRef.current = true;
                releaseClock();
                const nextShiftStart = await getNextShiftStart(user.uid, newest.shiftStart);
                openShiftPrompt({ mode: 'clockin', shift: newest, nextShiftStart });
                return;
            }
            // decision === 'none' → fall through to the normal create below.
        }

        // Normal create — the lock + 8s backstop are already armed; set the pending
        // action so the server-ack releases exactly as before. Payload unchanged —
        // tech-path rules require serverTimestamp shiftStart, shiftEnd null,
        // userId === auth.uid. Do not alter these fields.
        pendingActionRef.current = 'in';
        const shiftsRef = collection(db, `users/${user.uid}/shifts`);
        try {
            await addDoc(shiftsRef, {
                shiftStart: serverTimestamp(),
                shiftEnd: null,
                organizationId: currentUserProfile.organizationId,
                userId: user.uid,
                userName: currentUserProfile.name,
            });
            console.log('clkdbg-7b2e4f16 addDoc promise RESOLVED (server-committed) — clock-IN'); // clkdbg-7b2e4f16 TEMP — proves when the write is server-acked
        } catch (error) {
            console.error("Error clocking in:", error);
            releaseClock(); // write threw — no transition to wait for, re-enable now
        }
    };

    const handleClockOut = async () => {
        if (!activeShift?.id || !user?.uid) return;
        if (clockBusyRef.current || shiftPromptOpenRef.current) return; // clkout-7e8f9a0b + clkstale-a5f0d7e2 — re-entry guard incl. an open prompt
        // clkstale-a5f0d7e2 — a shift open >= STALE_MS gets a self-report prompt
        // instead of a machine stamp. Guard NOT armed here; it arms only at submit,
        // so the 8s fallback never runs while the modal waits on the human.
        if (classifyClockOut(activeShift.shiftStart, Date.now()) === 'promptStale') {
            shiftPromptOpenRef.current = true; // clkstale-a5f0d7e2 — gate BEFORE the async next-shift lookup so a double-tap can't open two prompts
            const nextShiftStart = await getNextShiftStart(user.uid, activeShift.shiftStart);
            openShiftPrompt({ mode: 'clockout', shift: activeShift, nextShiftStart });
            return;
        }
        clockBusyRef.current = true;
        setClockBusy(true);
        pendingActionRef.current = 'out';
        clockFallbackRef.current = setTimeout(releaseClock, 8000);
        const shiftDocRef = doc(db, `users/${user.uid}/shifts`, activeShift.id);
        try {
            await updateDoc(shiftDocRef, {
                shiftEnd: serverTimestamp()
            });
            console.log('clkdbg-7b2e4f16 updateDoc promise RESOLVED (server-committed) — clock-OUT'); // clkdbg-7b2e4f16 TEMP — proves when the write is server-acked
        } catch (error) {
            console.error("Error clocking out:", error);
            releaseClock(); // write threw — re-enable now
        }
    };

    return (
        <div>
            <main>
                {(() => {
                    // doced-8f3a61c2 — the estimate page owns /estimates/*; nothing else draws over it.
                    if (activeView === 'estimate-page') {
                        if (!companySettings || Object.keys(companySettings).length === 0) {
                            return <div className="p-20 text-center text-gray-500 animate-pulse">Loading…</div>;
                        }
                        if (!can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS)) {
                            return <div className="max-w-xl mx-auto px-4 py-16 text-center text-gray-700">You don’t have access to estimates. Ask an Owner or Admin if you need it.</div>;
                        }
                        if (estimatePagesOn) estimatePageLatchRef.current = true;
                        else if (!estimatePageLatchRef.current) return <Navigate to="/quotes" replace />;
                        return (
                            <EstimatePage
                                orgId={currentUserProfile?.organizationId}
                                user={user}
                                currentUserProfile={currentUserProfile}
                                companySettings={companySettings}
                                customers={customers}
                                users={users}
                                prefill={estimatePrefill}
                                onConvertToInvoice={handleConvertToInvoice}
                                onConvertToJob={handleConvertToJob}
                                onReQuoteDeclined={handleReQuoteDeclinedItems}
                                onViewJob={handleViewJob}
                                isConverting={isConverting}
                                awaitClosePrompt={awaitClosePrompt}
                                onClosePromptHandled={() => setAwaitClosePrompt(null)}
                                onClosingSave={(quoteId) => setAwaitClosePrompt({ quoteId, since: Date.now() })}
                            />
                        );
                    }
                    if (loadingDeepLink) {
                        return <div className="p-20 text-center text-gray-500 animate-pulse">Loading item...</div>;
                    }

                    if (viewingInvoice) {
                        return <InvoiceDetailsView
                            invoice={viewingInvoice}
                            companySettings={companySettings}
                            onBack={() => { setViewingInvoice(null); navigate('/invoices'); }}
                            onEditInvoice={openInvoiceModal}
                            currentUserProfile={currentUserProfile}
                            onOpenCustomer={openCustomerModal}
                            openRecordPayment={recordPaymentForId === viewingInvoice.id} // h1s6-8b2f4d19
                            onRecordPaymentOpened={() => setRecordPaymentForId(null)}
                        />;
                    }
                    if (viewingSchedule) { // recinv-crmapp-view-5d2b8e10
                        return <RecurringInvoiceDetailsView
                            schedule={viewingSchedule}
                            currentUserProfile={currentUserProfile}
                            onBack={() => { setViewingSchedule(null); navigate('/recurring-invoices'); }}
                            onInvoiceSelect={setViewingInvoice}
                            onEdit={openScheduleModal}
                        />;
                    }
                    if (viewingQuote) {
                        // calreturn-7b2e9d41 — when this estimate was opened FROM the
                        // calendar (a follow-up click or a follow-up search result), go
                        // back to that exact calendar URL and label the link for it.
                        //
                        // Clearing viewingQuote is NOT optional. The deep-link effect only
                        // nulls it while the resource is still `quotes`, so navigating
                        // straight to /calendar would leave it set and pop this view open
                        // again the next time he opens the Quotes tab.
                        const quoteReturnTo = location.state?.returnTo;
                        const quoteReturnsToCalendar = typeof quoteReturnTo === 'string'
                            && quoteReturnTo.startsWith('/calendar');
                        return <QuoteDetailsView
                                    quote={viewingQuote}
                                    companySettings={companySettings}
                                    onBack={() => {
                                        setViewingQuote(null);
                                        if (quoteReturnTo) navigate(quoteReturnTo);
                                    }}
                                    backLabel={quoteReturnsToCalendar ? 'Calendar' : null}
                                    orgId={currentUserProfile?.organizationId}
                                    currentUserProfile={currentUserProfile}
                                    onEditQuote={openQuoteModal} 
                                    onConvertToInvoice={handleConvertToInvoice} 
                                    onConvertToJob={handleConvertToJob} 
                                    onReQuoteDeclined={handleReQuoteDeclinedItems}
                                    onViewJob={handleViewJob}
                                    isConverting={isConverting}
                                    awaitClosePrompt={awaitClosePrompt}
                                    onClosePromptHandled={() => setAwaitClosePrompt(null)}
                                />;
                    }
                    if (selectedCustomer) {
                        // PHASE 1.6.1 VERIFIER: r1-161-web-crmapp-customer-deeplink-4f1c8d2a
                        // initialTab pulled from ?tab= URL param so note_flag bell-clicks
                        // and Flagged Inbox Open both land on the Notes & Media tab. The
                        // notificationRouting.js note_flag + getNoteAttachmentRoute cases
                        // bake ?tab=notesMedia into the URL for customer destinations.
                        // Default 'history' matches CustomerFormModal's initialTab default
                        // (line 34) so direct /customers/:id navigation (no query) is
                        // unchanged from pre-1.6.1 behavior.
                        return <CustomerFormModal 
                                    editingCustomer={selectedCustomer} 
                                    initialTab={new URLSearchParams(location.search).get('tab') || 'history'}
                                    closeModal={() => setSelectedCustomer(null)} 
                                    user={user} 
                                    currentUserProfile={currentUserProfile} 
                                    customers={customers || []}
                                    isEmailConnected={isOutlookConnected} // googleoff-7d2e4a19 -- Microsoft is the only email provider
                                    onComposeRequest={handleComposeRequest}
                                    onDeleteRequest={handleDeleteCustomer} 
                                    onQuoteSelect={handleQuoteSelect} 
                                    openQuoteModal={openQuoteModal} 
                                    companySettings={companySettings} 
                                    onConvertToInvoice={handleConvertToInvoice} 
                                    openInvoiceModal={openInvoiceModal}
                                    onInvoiceSelect={handleInvoiceSelect}
                                    openJobEditorModal={openJobEditorModal}
                                    onConvertToJob={handleConvertToJob} 
                                    onViewJob={handleViewJob}
                                    onRequestJobStart={handleSelectCalendarJob} 
                                />;
                    }
                
                    switch(activeView) {
                        case 'quotes':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_FINANCIALS} currentUserProfile={currentUserProfile}>
                                    {/* users: qboard-7e3c9b42 — the board shows the salesperson's NAME and offers a salesperson filter; salesPersonId on a quote is a uid, and this array is the only place a name for it lives. Already loaded for other views, so no new listener. */}
                                    <QuotesView currentUserProfile={currentUserProfile} onQuoteSelect={handleQuoteSelect} openQuoteModal={openQuoteModal} companySettings={companySettings} users={users} /> {/* r1-p1-docterm-crmqv-4b8e2f61 */}
                                </ProtectedRoute>
                            );

                        // D1 VERIFIER: r1-d1-jobeditor-case-5c1a7e63
                        // Full-page routed job editor. Renders the SAME JobFormModal
                        // the old overlay mount rendered (identical props), but as a
                        // full-page view driven by the /jobs/:id/edit | /jobs/new URL
                        // instead of the isJobModalOpen overlay. editingJob remains
                        // the source of truth. Cold-load (refresh/deep-link with a
                        // null editingJob) is handled by a separate effect (apply-step 5).
                        case 'job-editor':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_JOBS} currentUserProfile={currentUserProfile}>
                                    <JobFormModal
                                        key={editingJob?.id ? `edit-${editingJob.id}` : 'new-job'}
                                        isOpen={true}
                                        onClose={closeJobModal}
                                        currentUserProfile={currentUserProfile}
                                        jobToEdit={editingJob}
                                        onSave={closeJobModal}
                                        onGenerateInvoice={handleGenerateInvoiceFromJob}
                                        employees={users}
                                        customers={customers}
                                        services={services}
                                        jobs={jobs}
                                        resources={resources}
                                        companySettings={companySettings}
                                    />
                                </ProtectedRoute>
                            );

                        case 'jobs':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_JOBS} currentUserProfile={currentUserProfile}>
                                    <JobManagementView
                                        currentUserProfile={currentUserProfile}
                                        openJobEditorModal={openJobEditorModal}
                                        onRequestJobStart={handleSelectCalendarJob}
                                        onGenerateInvoice={handleGenerateInvoiceFromJob}
                                        techJobCreationEnabled={companySettings?.techJobCreationEnabled === true}
                                        orgTimeZone={companySettings?.timezone} // orgtime-7c2e4b19
                                        visitWallClockEnabled={companySettings?.visitWallClockEnabled} // tzhour-6a3d9c58
                                    />
                                </ProtectedRoute>
                            );

                        case 'recurring-invoices': // recinv-crmapp-case-7a1f3c86
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_FINANCIALS} currentUserProfile={currentUserProfile}>
                                    <RecurringInvoicesView
                                        currentUserProfile={currentUserProfile}
                                        onScheduleSelect={setViewingSchedule}
                                        onNew={() => openScheduleModal(null)}
                                    />
                                </ProtectedRoute>
                            );

                        case 'invoices':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_FINANCIALS} currentUserProfile={currentUserProfile}>
                                    <InvoicesView
                                        currentUserProfile={currentUserProfile} 
                                        onInvoiceSelect={setViewingInvoice} 
                                        openInvoiceModal={openInvoiceModal}
                                        sortConfig={invoiceSortConfig}
                                        onSortChange={setInvoiceSortConfig}
                                        companySettings={companySettings}
                                    />
                                    {/* qbcol-8a05c1de InvoicesView receives companySettings to gate the QB column */}
                                </ProtectedRoute>
                            );
                            
                        case 'calendar':
                            return <CalendarView 
                                        user={user} 
                                        currentUserProfile={currentUserProfile} 
                                        onAddJob={openJobEditorModal} 
                                        onSelectJob={handleSelectCalendarJob} 
                                        onUpdateJob={handleUpdateJob}
                                        onJobMoved={handleJobMoved}
                                        onCreateRecurringException={handleCreateRecurringException}
                                        onRecordRecurringException={handleRecordRecurringException}
                                        selectedEmployees={selectedEmployees}
                                        onEmployeeFilterChange={handleEmployeeFilterChange}
                                        onEmployeeFilterSetAll={handleEmployeeFilterSetAll} // calsel-6b2f9d34
                                        employees={users} // --- FIX: Re-added this critical prop ---
                                        companySettings={companySettings} // qattn-8c4e1f92-cal-tz — ORG timezone for the shared follow-up-overdue rule
                                    />;
                                    
                        case 'requests':
                            return <RequestsView currentUserProfile={currentUserProfile} onCreateQuote={handleCreateQuoteFromRequest} onViewCustomer={openCustomerModal} initialRequestId={initialEntityId} clearInitialRequestId={() => setInitialEntityId(null)} onBookNow={handleBookNow} />;
                            
                        case 'email':
                            // googleoff-7d2e4a19 -- stale Gmail flags must not open the Gmail inbox path
                            const isAnyEmailConnected = isOutlookConnected;
                            return <EmailView user={user} composeState={composeState} onComposeRequest={handleComposeRequest} onComposeClose={handleComposeClose} isConnected={isAnyEmailConnected} onConnect={handleConnectionChange} onProviderChange={setEmailProvider} accessToken={emailAccessToken} tokenExpiresAt={emailTokenExpiresAt} emailProvider={emailProvider} />;
                            
                        // PHASE 1.6 VERIFIER: r1-16-web-crmapp-route-16a3f2b8
                        // Phase 1.6 — Flagged-note triage inbox. Live view of
                        // unresolved flagged notes assigned to the current user.
                        // Props mirror the existing view conventions; orgUsers
                        // wired through for future Reassign-in-row work even
                        // though sub-batch 3.2 doesn't consume it yet.
                        case 'flagged':
                            return <FlaggedInbox
                                currentUserProfile={currentUserProfile}
                                orgUsers={users}
                                orgId={currentUserProfile?.organizationId}
                            />;
                            
                        case 'reports':
                            // qreport-5b8e2c64 — a Sales Consultant (no VIEW_REPORTS) gets a
                            // Reports page at exactly /reports listing only their own
                            // Estimates report. Every other /reports/* path below is
                            // unchanged and still requires VIEW_REPORTS.
                            if (/^\/reports\/?$/.test(location.pathname)
                                && !can(currentUserProfile, PERMISSIONS.VIEW_REPORTS)
                                && resolveReportViewer(currentUserProfile).access === 'scoped') {
                                return <EstimatesOnlyReportsHome companySettings={companySettings} />;
                            }
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_REPORTS} currentUserProfile={currentUserProfile}>
                                    {(() => {
                                         const path = location.pathname;
                                         if (path.includes('/overdue')) return <OverdueEventsReport currentUserProfile={currentUserProfile} openJobEditorModal={openJobEditorModal} />;
                                         if (path.includes('/cancellations')) return <CancellationReport currentUserProfile={currentUserProfile} openJobEditorModal={openJobEditorModal} />;
                                         if (path.includes('/profitability')) return <ProfitabilityReport currentUserProfile={currentUserProfile} />;
                                         if (path.includes('/service-revenue')) return <ServiceRevenueReport currentUserProfile={currentUserProfile} />;
                                         if (path.includes('/expenses')) return <ExpenseReportView currentUserProfile={currentUserProfile} />;
                                         return <ReportsHome currentUserProfile={currentUserProfile} companySettings={companySettings} />; // qreport-5b8e2c64
                                    })()}
                                </ProtectedRoute>
                            );

                        case 'timesheets':
                            // tsmgr-5a2c8e71 — was ProtectedRoute(COMPLETE_JOBS), which bounced every
                            // Manager to /home. Same helper as the Sidebar item; same redirect on refusal.
                            if (!canOpenTimesheets(currentUserProfile)) return <Navigate to="/home" replace />;
                            return (
                                <TimesheetsView
                                    currentUserProfile={currentUserProfile}
                                    onApproveTimesheet={handleApproveTimesheet}
                                    onJobSelect={handleSelectCalendarJob}
                                />
                            );

                        case 'customers':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_CUSTOMERS} currentUserProfile={currentUserProfile}>
                                    <CustomerManagementView user={user} currentUserProfile={currentUserProfile} companySettings={companySettings} onComposeRequest={handleComposeRequest} isEmailConnected={isOutlookConnected} onCustomerSelect={(customer) => setSelectedCustomer(customer)} openCustomerModal={openCustomerModal} />
                                </ProtectedRoute>
                            );
                        
                        case 'employees':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_HR} currentUserProfile={currentUserProfile}>
                                    <EmployeeProfilesView 
                                        currentUserProfile={currentUserProfile}
                                        openEmployeeModal={openEmployeeModal}
                                    />
                                </ProtectedRoute>
                            );
                        
                        case 'hiring':
                             return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.MANAGE_HIRING} currentUserProfile={currentUserProfile}>
                                     <div className="p-10 text-center">Hiring Board Placeholder</div> 
                                </ProtectedRoute>
                             );

                        case 'marketing':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.MANAGE_MARKETING} currentUserProfile={currentUserProfile}>
                                    <EmailCampaignsView 
                                        currentUserProfile={currentUserProfile}
                                    />
                                </ProtectedRoute>
                            );
                            
                        case 'routes':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.VIEW_ROUTES} currentUserProfile={currentUserProfile}>
                                    <RoutesView
                                        currentUserProfile={currentUserProfile}
                                        employees={users}
                                        openJobEditorModal={openJobEditorModal}
                                        onRequestJobStart={handleSelectCalendarJob}
                                    />
                                </ProtectedRoute>
                            );

                        case 'schedule':
                            return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.MANAGE_SCHEDULE} currentUserProfile={currentUserProfile}>
                                    <WeeklyPlannerView
                                        currentUserProfile={currentUserProfile}
                                        employees={users}
                                    />
                                </ProtectedRoute>
                            );

                        case 'expenses':
                             return (
                                <ProtectedRoute requiredPermission={PERMISSIONS.MANAGE_EXPENSES} currentUserProfile={currentUserProfile}>
                                     <ExpensesView currentUserProfile={currentUserProfile} />
                                </ProtectedRoute>
                             );

                        case 'sops':
                            // sopweb-bdb7afcd — the same check as the Sidebar entry. Wait for the company
                            // record before deciding, so a /sops link opened cold doesn't bounce to Home.
                            if (!companySettings || Object.keys(companySettings).length === 0) {
                                return <div className="p-20 text-center text-gray-500 animate-pulse">Loading…</div>;
                            }
                            if (!showSopsMenu(currentUserProfile, companySettings)) return <Navigate to="/home" replace />;
                            return <SopsPage currentUserProfile={currentUserProfile} users={users} companySettings={companySettings} />;

                        case 'settings':
                            return <SettingsPage
                                        user={user}
                                        currentUserProfile={currentUserProfile}
                                        companySettings={companySettings}
                                        isGmailConnected={isGmailConnected}
                                        isCalendarConnected={isCalendarConnected}
                                        isOutlookConnected={isOutlookConnected}
                                        isMsCalendarConnected={isMsCalendarConnected}
                                        activeTab={settingsTab}
                                        onTabChange={setSettingsTab}
                                    />;
                        case 'home':
                        default:
                            return <HomeView
                                       currentUserProfile={currentUserProfile}
                                       openJobEditorModal={openJobEditorModal}
                                       activeShift={activeShift}
                                       onClockIn={handleClockIn}
                                       onClockOut={handleClockOut}
                                       clockBusy={clockBusy}
                                   />;
                    }
                })()}
            </main>

            {/* quotelock-8b4e1c07 -- mount the quote builder only for finance roles,
                mirroring the invoice mount (invlock-5a9d3f07). NOT redundant with the
                openQuoteModal guard: handleCreateQuoteFromRequest and
                handleReQuoteDeclinedItems call setIsQuoteModalOpen(true) directly,
                bypassing the opener entirely. This is the layer that catches those. */}
            {isQuoteModalOpen && can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS) && (
                <QuoteFormModal
                    closeModal={closeQuoteModal}
                    editingQuote={editingQuote}
                    currentUserProfile={currentUserProfile}
                    companySettings={companySettings}
                    customers={customers}
                    services={services}
                    orgUsers={users}
                />
            )}

            {isCustomerModalOpen && (
                <CustomerFormModal
                    closeModal={closeCustomerModal}
                    editingCustomer={editingCustomer}
                    user={user}
                    currentUserProfile={currentUserProfile}
                    customers={customers || []} 
                    initialTab={initialCustomerModalTab}
                    onDeleteRequest={handleDeleteCustomer}
                    onComposeRequest={handleComposeRequest}
                    isEmailConnected={isOutlookConnected} // googleoff-7d2e4a19 -- Microsoft is the only email provider
                    openQuoteModal={openQuoteModal}
                    companySettings={companySettings}
                    onConvertToInvoice={handleConvertToInvoice}
                    openInvoiceModal={openInvoiceModal}
                    onInvoiceSelect={handleInvoiceSelect}
                    openJobEditorModal={openJobEditorModal}
                    onConvertToJob={handleConvertToJob} 
                    onReQuoteDeclined={handleReQuoteDeclinedItems}
                    onRequestJobStart={handleSelectCalendarJob} 
                />
            )}
            
            {/* D1 VERIFIER: r1-d1-remove-overlay-mount-8e6b1f42
                Legacy centered-overlay JobFormModal mount removed. The editor now
                renders full-page via `case 'job-editor'` in the switch above,
                driven by the /jobs/:id/edit | /jobs/new URL. The old key-collision
                guard (r1-fu-bug-9e3a5c81) is retired here: with QuickView no longer
                a rendered sibling of the editor, the duplicate-key class is gone.
                isJobModalOpen state is now vestigial (kept only so closeJobModal's
                setter is harmless) — safe to remove in a later cleanup pass. */}

            <JobQuickViewModal
                // PHASE 1.4 VERIFIER: r1-2b71c849
                // key forces clean remount whenever the target job changes.
                // QuickView is rendered unconditionally (no isOpen wrapper), so
                // it keeps the same instance across job switches and any internal
                // state cached on initial mount stays stale. The key makes React
                // tear down + re-mount on every job change.
                // PHASE FU-BUG VERIFIER: r1-fu-bug-9e3a5c81
                // Prefix added so this key can never collide with JobFormModal's
                // key (which uses raw job.id). Belt-and-suspenders for the
                // duplicate-key React reconciliation bug. handleEditFromQuickView
                // now also nulls quickViewJob explicitly which is the primary fix.
                key={quickViewJob?.id ? `quick-${quickViewJob.id}` : 'no-quickview-job'}
                isOpen={isQuickViewModalOpen}
                onClose={() => {
                    setIsQuickViewModalOpen(false);
                    setQuickViewJob(null);
                }}
                job={quickViewJob}
                currentUserId={user?.uid}
                currentUserName={currentUserProfile?.name}
                currentUserProfile={currentUserProfile}
                orgId={currentUserProfile?.organizationId} // r1-3i-crm-qvprops-7f2a9c14 — Notes & Media needs the full profile + orgId
                canEdit={can(currentUserProfile, PERMISSIONS.MANAGE_JOBS)
                    || canTechEditJob(currentUserProfile, companySettings, quickViewJob)}
                onStartTimer={handleStartTimer}
                onStopTimer={handleStopTimer}
                onCompleteJob={handleCompleteJob}
                onEdit={handleEditFromQuickView}
                onAddWorkPerformedEntry={handleAddWorkPerformedEntry}
                onEditWorkPerformedEntry={handleEditWorkPerformedEntry}
                onRemoveWorkPerformedEntry={handleRemoveWorkPerformedEntry}
                onAddTechLineItem={handleAddTechLineItem}
                orgUsers={users}
                resources={resources}
                onUpdateResources={handleUpdateResources}
                jobs={jobs}
            />
            {/* invlock-5a9d3f07 -- mount the editable invoice modal only for finance roles.
                Redundant with the openInvoiceModal guard above; kept so no future caller
                can flip isInvoiceModalOpen and surface the editable form to a technician. */}
            {isInvoiceModalOpen && can(currentUserProfile, PERMISSIONS.MANAGE_FINANCIALS) && (
                <InvoiceFormModal
                    closeModal={closeInvoiceModal}
                    editingInvoice={editingInvoice}
                    currentUserProfile={currentUserProfile}
                    companySettings={companySettings}
                    customers={customers}
                    user={user}
                    services={services}
                />
            )}
            {isScheduleModalOpen && ( // recinvform-crmapp-render-9f3c2a71
                <RecurringInvoiceFormModal
                    closeModal={closeScheduleModal}
                    editingSchedule={editingSchedule}
                    currentUserProfile={currentUserProfile}
                    companySettings={companySettings}
                    customers={customers}
                    user={user}
                    services={services}
                />
            )}
            
            {isEmployeeModalOpen && (
                <EmployeeProfileModal
                    closeModal={closeEmployeeModal}
                    editingEmployee={editingEmployee}
                    currentUserProfile={currentUserProfile}
                />
            )}

            {/* seamE-9d2e5b83 — warn before converting an estimate to an invoice a
                second time. Only rendered when a prior invoice was found (convertWarning
                set); a first conversion never reaches here. Same dialog shape both cases;
                the deposit sentence is present only when a deposit was actually consumed. */}
            {convertWarning && (() => {
                const estimateWord = resolveDocTerminology(convertWarning.quote?.docType).word.toLowerCase();
                const currency = companySettings?.currency || 'USD';
                const numbers = convertWarning.priorNumbers.join(', ');
                let message = `You already created invoice #${numbers} from this ${estimateWord}. Creating another makes a second, separate invoice — if you didn't mean to, this bills the customer twice for the same work.`;
                if (convertWarning.depositApplied) {
                    message += ` The ${formatCurrency(convertWarning.depositAmount, currency)} deposit was applied to invoice #${convertWarning.depositInvoiceNumber} and will not carry over — the new invoice will show no deposit credit.`;
                }
                return (
                    <ConfirmationModal
                        isOpen={true}
                        onClose={() => setConvertWarning(null)}
                        onConfirm={async () => {
                            const pending = convertWarning;
                            setConvertWarning(null);
                            await proceedWithConversion(pending.quote, pending.customer);
                        }}
                        title={`This ${estimateWord} already has an invoice`}
                        message={message}
                        confirmText="Create another invoice"
                    />
                );
            })()}

            {/* jobinvguard-5e1b7c84 — warn before invoicing a job a second time (same dialog as the
                estimate warning above). Only rendered when the job already has an invoice. */}
            {jobInvoiceWarningState && (() => {
                const w = jobInvoiceWarning(jobInvoiceWarningState.priorNumbers);
                return (
                    <ConfirmationModal
                        isOpen={true}
                        onClose={() => setJobInvoiceWarningState(null)}
                        onConfirm={async () => {
                            const pending = jobInvoiceWarningState;
                            setJobInvoiceWarningState(null);
                            await proceedWithJobInvoice(pending.job);
                        }}
                        title={w.title}
                        message={w.message}
                        confirmText={w.confirmText}
                    />
                );
            })()}

            {/* clkstale-a5f0d7e2 — self-report clock-out prompt (stale clock-out / clock-in branches) */}
            {shiftPromptOpen && (
                <ShiftClockOutPrompt
                    open={shiftPromptOpen}
                    mode={shiftPromptData?.mode}
                    shiftStart={shiftPromptData?.shift?.shiftStart}
                    nextShiftStart={shiftPromptData?.nextShiftStart}
                    onSubmit={submitSelfReport}
                    onCancel={cancelShiftPrompt}
                />
            )}
        </div>
    );
};

export default CrmApp;